const tokenCount = [
  "c8ad0d694eba98",
  "25241198af9c52",
      "843b85132fe7ea"
];
const SiteName = "HR365";
// const SiteName = "Apps365";


export function getRandomIPToken() {
  const randomIndex = Math.floor(Math.random() * tokenCount.length);
  console.log(tokenCount[randomIndex]);
  return tokenCount[randomIndex];
}


//Helpdesk1 or /microsoft-365-helpdesk-software

export const Helpdesk1FirstSection = {
  MainHeading:
    "Smarter Support, Happier Teams – Faster Ticketing with Helpdesk 365",
  MainDescription:
    "Manage tickets easily with our Microsoft 365 helpdesk that works perfectly with Microsoft 365. Help your team give faster and better support without any hassle.",
  MainImageAlt: "Helpdesk 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/Helpdesk_OjlohM6cD.png",
};

export const Helpdesk1Overview = {
  MainHeading:
    "Experience the Perfect Blend of AI Smarts and Human Care with Help Desk 365",
  MainDescription:
    "Get the best of AI smart and human touch—deliver happiness right out of the box. Our SharePoint ticketing system gets you going fast with simplified workflows that let your employees glide through tasks effortlessly. As well as you can use our Help desk software easily within Microsoft 365 apps like Teams, Outlook, and SharePoint.",
  MainImageAlt: "Teams Helpdesk 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/hr365/SPFxEDP/site-Helpdesk/HD365%20Teams_bGn7Gudo4J.png?updatedAt=1701258105168",
};
export const hd1tab1 = [
  {
    id: 1,
    title: "Focus on what you need",
    Heading:
      "Prioritize What Truly Matters: Simplify with Microsoft it helpdesk",
    content: (
      <ul>
        <li>
          {" "}
          Simplify ticket management with Microsoft service desk software that
          organizes tickets by priority, category, time, and status.
        </li>
        <li>
          {" "}
          Effortless request submission through the SharePoint portal via email
          or an embedded web part.
        </li>
        <li>
          Seamless collaboration with Microsoft Teams integration, offering
          conversational support for your team.
        </li>
        <li>
          Boost productivity and satisfaction by streamlining request tracking
          across IT, HR, and other departments.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Recording4-ezgif.com-video-to-gif-converter_1t1BQO-ac.gif?updatedAt=1718713728955",
  },
  {
    id: 2,
    title: "Features",
    Heading:
      "AI-Powered Ticket Management Features",
    content: (
      <ul>
        <li>
          Seamlessly manage tickets inside Microsoft Teams for faster collaboration.
        </li>
        <li>
          AI-powered automation routes issues to the right agent instantly for rapid, accurate resolution.
        </li>
        <li>
          Streamline workflows: auto-assign, track, and close tickets effortlessly.
        </li>
        <li>
          AI Copilot suggests replies and solutions, accelerating every resolution.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/TicketManagement_NawCmGYkO.gif?updatedAt=1719903031399",
  },
  {
    id: 3,
    title: "Improve Efficiency",
    Heading:
      "Improve Efficiency with SLAs in Our Microsoft Helpdesk Ticketing System",
    content: (
      <ul>
        Make service delivery smoother and more dependable with HR365’s
        Microsoft helpdesk solution—designed to keep both your team and
        customers happy.
        <li>
          Reliable Service with SLAs: Count on consistent support and keep
          customers satisfied with strong Service Level Agreements (SLAs).
        </li>
        <li>
          Actionable Insights: Use detailed reports and analytics to spot
          performance gaps and improve your service.
        </li>
        <li>
          Timely Responses: Automated SLA tracking and alerts help your team
          stay on top, ensuring quick responses and fast issue resolution.
        </li>
        <li>
          Tailored to Your Needs: Customize SLA templates to create service
          levels that fit your organization’s goals perfectly.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/SLA_SKQ5cy1rQf.gif?updatedAt=1719814962251",
  },
  {
    id: 4,
    title: "Easy Customization",
    Heading:
      "Microsoft help desk app Work Perfectly for You with Easy Customization",
    content: (
      <ul>
        <li>
          Improve your support experience with our flexible Microsoft help desk
          ticketing software, seamlessly integrated with SharePoint.
        </li>
        <li>
          Easily assign tickets, prioritize tasks, and keep everyone updated
          with streamlined notifications.
        </li>
        <li>
          Boosts productivity, streamlines workflows, and speeds up response
          times, creating a supportive environment that goes above and beyond.
        </li>
        <li>
          Advanced reporting and analytics help you spot trends and improve team
          performance for continuous growth.
        </li>
        <li>
          Integration with Microsoft Teams allows your support staff to
          collaborate and communicate in real-time, solving issues faster.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/approve_Q5cb5xjOH.gif?updatedAt=1719898618060",
  },
];
export const hd1tab2 = [
  {
    id: 1,
    title: " Support Experience ",
    Heading:
      "Transform Your Support with Cutting-edge Microsoft help desk application Features",
    content: (
      <ul>
        <li>
          Empower customer support with our comprehensive ticketing system,
          boosting productivity.
        </li>
        <li>
          Clients can easily request tickets and get instant status updates
          through our intuitive platform.
        </li>
        <li>
          The SharePoint ticketing system not only tracks tickets but also helps
          identify solutions, with quick access to historical data and a
          knowledge base, accelerating issue resolution and reducing new ticket
          submissions.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Supportexp_eht3Bt82e6.gif?updatedAt=1719903031166",
  },
  {
    id: 2,
    title: "Security Measures",
    Heading: "Enhanced Security for Identity and Access Management",
    content: (
      <ul>
        <li>
          Microsoft 365 help desk ticketing system ensures security with robust
          identity and access management. Integrated with Microsoft 365, it
          employs a safe strategy with multiple security layers.
        </li>
        <li>
          These measures, along with stringent practices, protect your Microsoft
          ticketing system against threats and unauthorized access. For detailed
          insights into our security protocols, contact Apps365.
        </li>
        <li>
          Regular security updates and vulnerability assessments ensure ongoing
          protection and adaptation to emerging threats.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Securitymeasures_SLoTGlIE5.gif?updatedAt=1719903031258",
  },
  {
    id: 3,
    title: "Customer Support",
    Heading:
      "Transform Customer Support and Drive Operational Excellence with ticket system SharePoint",
    content: (
      <ul>
        <li>
          Help desk for Microsoft teams enhances customer service by providing
          insightful reports to gauge satisfaction and optimize team
          performance.
        </li>
        <li>
          It uncovers actionable insights for immediate improvements, ensuring a
          seamless experience for both teams and clients.
        </li>
        <li>
          Automated ticketing and workflow management streamline support
          processes, reducing response times and increasing efficiency.
        </li>
        <li>
          Customizable dashboards and metrics allow for tailored performance
          tracking and reporting to meet specific business needs.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/boast_xwE5iohIU.gif?updatedAt=1719904751386",
  },
  {
    id: 4,
    title: "Rules and Automation",
    Heading: "Drive Efficiency with Customized Rules and Automation",
    content: (
      <ul>
        <li>
          Boost operational efficiency with Apps365’s 'Rule & Automation'
          feature. Customize and automate ticket management by creating advanced
          rules for generating, assigning, and routing tickets based on your
          needs.
        </li>
        <li>
          Boost operational efficiency with Apps365’s 'Rule & Automation'
          feature. Customize and automate ticket management by creating advanced
          rules for generating, assigning, and routing tickets based on your
          needs.
        </li>
        <li>
          Automated escalation protocols ensure critical issues receive
          immediate attention, reducing resolution times for high-priority
          tickets.
        </li>
        <li>
          Flexible rule configuration allows for dynamic adjustments to
          workflows, adapting to changing operational requirements and
          priorities.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Rules&automation_qYBfGojFe.gif?updatedAt=1719903031561",
  },
];
export const Helpdesk1FAQs = [
  {
    title: " How do I create a ticket in Microsoft?",
    content: (
      <ul>
        To create a ticket in Microsoft Helpdesk 365:
        <li>Open Microsoft Teams and go to the Helpdesk 365 app.</li>
        <li>Click New Ticket to start.</li>
        <li>
          Fill in the details, including the issue, priority, and any
          attachments.
        </li>
        <li>Submit the ticket, and it’s instantly logged.</li>
        You can track updates and communicate with the support team directly in
        Teams.
      </ul>
    ),
  },
  {
    title: "Can you use Microsoft Teams as a ticketing system?",
    content:
      "Using Microsoft Teams as a helpdesk 365 ticketing system enables employees to get instant support and resolve issues faster. Both employees and the support team collaborate easily on the same platform, with the added benefit of 24/7 accessibility for continuous assistance.",
  },
  {
    title: "Is SharePoint a Ticketing System?",
    content: (
      <ul>
        SharePoint a collaboration platform for managing documents and workflows
        for millions of Microsoft 365 users. However, you can customize it for
        ticket tracking and effective communication using:
        <li>Lists: To log and track tickets.</li>
        <li>Workflows: For automating assignments and updates.</li>
        <li>Power Automate: For advanced automation.</li>
        For a more robust ticketing solution, tools like Helpdesk 365 integrate
        seamlessly with SharePoint. So that you can easily manage your
        SharePoint ticketing system with more efficiency.
      </ul>
    ),
  },
  {
    title: "What is a SharePoint system?",
    content:
      "SharePoint is a web-based platform that improves your organization efficiency by simplifying data management and access. SharePoint serves as an enterprise information hub, easily customizable to support intranet, extranet, and internet sites.",
  },
  {
    title: "Which Tools is SharePoint?",
    content:
      "Organizations use Microsoft SharePoint to create websites. You can use it as a secure place to store, organize, share, and access information from any device. All you need is a web browser, such as Microsoft Edge, Internet Explorer, Chrome, or Firefox. Want to learn more?",
  },
];

export const Helpdesk1MetaTag = {
  Title: "Helpdesk Software for Microsoft 365 | Fast, Secure, and Reliable",
  Description:
    "Helpdesk 365: Secure ticketing for IT, HR, and Finance. Seamlessly integrates with Microsoft 365. Easy to deploy, customizable, and efficient.",
};

export const Helpdesk1Features = [
  {
    MainHeading: "Feature1",
    MainDescription: "Description1",
    MainImageSrc: "",
    MainImageAlt: "MainImage1",
  },
  {
    MainHeading: "Feature2",
    MainDescription: "Description2",
    MainImageSrc: "",
    MainImageAlt: "MainImage2",
  },
];
// Second Page

export const Helpdesk2FirstSection = {
  MainHeading:
    "Smarter Support, Happier Teams – Faster Ticketing with Helpdesk 365",
  MainDescription:
    "Manage tickets easily with our Microsoft 365 helpdesk that works perfectly with Microsoft 365. Help your team give faster and better support without any hassle.",
  MainImageAlt: "Helpdesk 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/Helpdesk_OjlohM6cD.png",
};

//3rd Page
export const Helpdesk3FirstSection = {
  MainHeading:
    "Second HD Smarter Support, Happier Teams – Faster Ticketing with Helpdesk 365",
  MainDescription:
    "Manage tickets easily with our Microsoft 365 helpdesk that works perfectly with Microsoft 365. Help your team give faster and better support without any hassle.",
  MainImageAlt: "Helpdesk 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/Helpdesk_OjlohM6cD.png",
};
export const hd3tab1 = [
  {
    id: 1,
    title: "Focus on what you need",
    Heading:
      "Prioritize What Truly Matters: Simplify with SharePoint Ticket System",
    content: (
      <ul>
        <li>
          Simplify ticket management with SharePoint based ticketing system that
          organizes tickets by priority, category, time, and status.
        </li>
        <li>
          Effortless request submission through the SharePoint portal via email
          or an embedded web part.
        </li>
        <li>
          Seamless collaboration with Microsoft Teams integration, offering
          conversational support for your team.
        </li>
        <li>
          Boost productivity and satisfaction by streamlining request tracking
          across IT, HR, and other departments.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Recording4-ezgif.com-video-to-gif-converter_1t1BQO-ac.gif?updatedAt=1718713728955",
  },
  {
    id: 2,
    title: "Ticket Management",
    Heading:
      "AI-Powered Ticket Management Features",
    content: (
      <ul>
        <li>
          {" "}
          Seamlessly manage tickets inside Microsoft Teams for faster collaboration. 
        </li>
        <li>
          {" "}
         AI-powered automation routes issues to the right agent instantly for rapid, accurate resolution. 
        </li>
        <li>
          {" "}
         Streamline workflows: auto-assign, track, and close tickets effortlessly. 
        </li>
        <li>
          Leverage Copilot to get real-time suggestions, auto-draft responses, and streamline support tasks—directly within your ticketing system
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/TicketManagement_NawCmGYkO.gif?updatedAt=1719903031399",
  },
  {
    id: 3,
    title: "SLA on cloud-based ",
    Heading: "Improve Efficiency with SLAs in Our Cloud-Based Ticketing System",
    content: (
      <ul>
        Make service delivery smoother and more dependable with HR365’s
        cloud-based IT ticketing platform—designed to keep both your team and
        customers happy.
        <li>
          {" "}
          Reliable Service with SLAs: Count on consistent support and keep
          customers satisfied with strong Service Level Agreements (SLAs).
        </li>
        <li>
          {" "}
          Actionable Insights: Use detailed reports and analytics to spot
          performance gaps and improve your service.
        </li>
        <li>
          Timely Responses: Automated SLA tracking and alerts help your team
          stay on top, ensuring quick responses and fast issue resolution.
        </li>
        <li>
          Tailored to Your Needs: Customize SLA templates to create service
          levels that fit your organization’s goals perfectly.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/SLA_SKQ5cy1rQf.gif?updatedAt=1719814962251",
  },
  {
    id: 4,
    title: "Easy Customization",
    Heading:
      "SharePoint Helpdesk Work Perfectly for You with Easy Customization",
    content: (
      <ul>
        <li>
          {" "}
          Improve your support experience with our flexible SharePoint support
          ticket system, seamlessly integrated with SharePoint.
        </li>
        <li>
          {" "}
          Easily assign tickets, prioritize tasks, and keep everyone updated
          with streamlined notifications.
        </li>
        <li>
          Boosts productivity, streamlines workflows, and speeds up response
          times, creating a supportive environment that goes above and beyond.
        </li>
        <li>
          {" "}
          Advanced reporting and analytics help you spot trends and improve team
          performance for continuous growth.
        </li>
        <li>
          Integration with Microsoft Teams allows your support staff to
          collaborate and communicate in real-time, solving issues faster.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/approve_Q5cb5xjOH.gif?updatedAt=1719898618060",
  },
];
export const hd3tab2 = [
  {
    id: 1,
    title: " Support Experience ",
    Heading:
      "Transform Your Support with Cutting-edge Microsoft Teams Ticketing System Features",
    content: (
      <ul>
        <li>
          Empower customer support with our comprehensive ticketing system,
          boosting productivity.
        </li>
        <li>
          Clients can easily request tickets and get instant status updates
          through our intuitive platform.
        </li>
        <li>
          The SharePoint ticketing system not only tracks tickets but also helps
          identify solutions, with quick access to historical data and a
          knowledge base, accelerating issue resolution and reducing new ticket
          submissions.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Supportexp_eht3Bt82e6.gif?updatedAt=1719903031166",
  },
  {
    id: 2,
    title: "Security Measures",
    Heading: " Enhanced Security for Identity and Access Management",
    content: (
      <ul>
        <li>
          SharePoint help desk ticketing system ensures security with robust
          identity and access management. Integrated with Microsoft 365, it
          employs a defense-in-depth strategy with multiple security layers.
        </li>
        <li>
          These measures, along with stringent practices, protect your Microsoft
          ticketing system against threats and unauthorized access. For detailed
          insights into our security protocols, contact Apps365.
        </li>
        <li>
          Regular security updates and vulnerability assessments ensure ongoing
          protection and adaptation to emerging threats.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Securitymeasures_SLoTGlIE5.gif?updatedAt=1719903031258",
  },
  {
    id: 3,
    title: "Boost Productivity",
    Heading:
      "Transform Customer Support and Drive Operational Excellence with ticket system SharePoint",
    content: (
      <ul>
        <li>
          Helpdesk software enhances customer service by providing insightful
          reports to gauge satisfaction and optimize team performance.
        </li>
        <li>
          It uncovers actionable insights for immediate improvements, ensuring a
          seamless experience for both teams and clients.
        </li>
        <li>
          Automated ticketing and workflow management streamline support
          processes, reducing response times and increasing efficiency.
        </li>
        <li>
          Customizable dashboards and metrics allow for tailored performance
          tracking and reporting to meet specific business needs.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/boast_xwE5iohIU.gif?updatedAt=1719904751386",
  },
  {
    id: 4,
    title: "Rules and Automation",
    Heading: "Drive Efficiency with Customized Rules and Automation",
    content: (
      <ul>
        <li>
          Boost operational efficiency with Apps365’s 'Rule & Automation'
          feature. Customize and automate ticket management by creating advanced
          rules for generating, assigning, and routing tickets based on your
          needs.
        </li>
        <li>
          This feature streamlines ITSM operations, ensures prompt attention to
          every ticket, and saves valuable time and resources.
        </li>
        <li>
          Automated escalation protocols ensure critical issues receive
          immediate attention, reducing resolution times for high-priority
          tickets.
        </li>
        <li>
          Flexible rule configuration allows for dynamic adjustments to
          workflows, adapting to changing operational requirements and
          priorities.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Rules&automation_qYBfGojFe.gif?updatedAt=1719903031561",
  },
];
//4th Page /sharepoint-ticketing-system

export const Helpdesk4FirstSection = {
  MainHeading:
    "Smarter Support, Happier Teams – Faster Ticketing with Helpdesk 365",
  MainDescription:
    "Manage tickets easily with our SharePoint ticketing system that works perfectly with Microsoft 365. Help your team give faster and better support without any hassle.",
  MainImageAlt: "Helpdesk 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/Helpdesk_OjlohM6cD.png",
};

//   export const Helpdesk4Features =
// [{
//     MainHeading: 'Feature1',
//     MainDescription: "Description1",
//     MainImageSrc: "",
//     MainImageAlt:"MainImage1"
// },
// {
//     MainHeading: 'Feature2',
//     MainDescription: "Description2",
//     MainImageSrc: "",
//     MainImageAlt:"MainImage2"
// }

// ]
export const hd4tab1 = [
  {
    id: 1,
    title: "Focus on what you need",
    Heading:
      "Prioritize What Truly Matters: Simplify with Microsoft ticketing system",
    content: (
      <ul>
        <li>
          Simplify ticket management with Microsoft outlook ticketing system
          that organizes tickets by priority, category, time, and status.
        </li>
        <li>
          Effortless request submission through the SharePoint portal via email
          or an embedded web part.
        </li>
        <li>
          Seamless collaboration with Microsoft Teams integration, offering
          conversational support for your team.
        </li>
        <li>
          Boost productivity and satisfaction by streamlining request tracking
          across IT, HR, and other departments.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Recording4-ezgif.com-video-to-gif-converter_1t1BQO-ac.gif?updatedAt=1718713728955",
  },
  {
    id: 2,
    title: "Ticket Management",
    Heading:
      "SharePoint-Based Ticket Management Features",
    content: (
      <ul>
        <li>
          {" "}
          Natively built on SharePoint for seamless ticket management. 
        </li>
        <li>
          {" "}
          Centralize ticket tracking and workflows natively inside SharePoint lists and sites. 
        </li>
        <li>
          {" "}
          Define clear service level agreements, set ticket priorities, and continuously track response and resolution times to ensure accountability. 
        </li>
        <li>
          Leverage Copilot to get real-time suggestions, auto-draft responses, and streamline support tasks—directly within your ticketing system. 
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/TicketManagement_NawCmGYkO.gif?updatedAt=1719903031399",
  },
  {
    id: 3,
    title: "SLA on cloud-based ",
    Heading:
      "Improve Efficiency with SLAs in Our Microsoft it ticketing system",
    content: (
      <ul>
        Make service delivery smoother and more dependable with HR365’s
        Microsoft ticketing software—designed to keep both your team and
        customers happy.
        <li>
          {" "}
          Reliable Service with SLAs: Count on consistent support and keep
          customers satisfied with strong Service Level Agreements (SLAs).
        </li>
        <li>
          {" "}
          Actionable Insights: Use detailed reports and analytics to spot
          performance gaps and improve your service.
        </li>
        <li>
          Timely Responses: Automated SLA tracking and alerts help your team
          stay on top, ensuring quick responses and fast issue resolution.
        </li>
        <li>
          Tailored to Your Needs: Customize SLA templates to create service
          levels that fit your organization’s goals perfectly.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/SLA_SKQ5cy1rQf.gif?updatedAt=1719814962251",
  },
  {
    id: 4,
    title: "Easy Customization",
    Heading:
      "Microsoft ticketing tool Work Perfectly for You with Easy Customization",
    content: (
      <ul>
        <li>
          Improve your support experience with our flexible Microsoft ticket
          management system, seamlessly integrated with SharePoint.
        </li>
        <li>
          {" "}
          Easily assign tickets, prioritize tasks, and keep everyone updated
          with streamlined notifications.
        </li>
        <li>
          Boosts productivity, streamlines workflows, and speeds up response
          times, creating a supportive environment that goes above and beyond.
        </li>
        <li>
          {" "}
          Advanced reporting and analytics help you spot trends and improve team
          performance for continuous growth.
        </li>
        <li>
          Integration with Microsoft Teams allows your support staff to
          collaborate and communicate in real-time, solving issues faster.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/approve_Q5cb5xjOH.gif?updatedAt=1719898618060",
  },
];

export const hd4tab2 = [
  {
    id: 1,
    title: " Support Experience ",
    Heading:
      "Transform Your Support with Cutting-edge Microsoft help desk application Features",
    content: (
      <ul>
        <li>
          Empower customer support with our comprehensive ticketing system,
          boosting productivity.
        </li>
        <li>
          Clients can easily request tickets and get instant status updates
          through our intuitive platform.
        </li>
        <li>
          The SharePoint ticketing system not only tracks tickets but also helps
          identify solutions, with quick access to historical data and a
          knowledge base, accelerating issue resolution and reducing new ticket
          submissions.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Supportexp_eht3Bt82e6.gif?updatedAt=1719903031166",
  },
  {
    id: 2,
    title: "Security Measures",
    Heading: " Enhanced Security for Identity and Access Management",
    content: (
      <ul>
        <li>
          Microsoft ticket tracking system ensures security with robust identity
          and access management. Integrated with Microsoft 365, it employs a
          safe strategy with multiple security layers.
        </li>
        <li>
          These measures, along with stringent practices, protect your Microsoft
          ticketing system against threats and unauthorized access. For detailed
          insights into our security protocols, contact Apps365.
        </li>
        <li>
          Regular security updates and vulnerability assessments ensure ongoing
          protection and adaptation to emerging threats.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Securitymeasures_SLoTGlIE5.gif?updatedAt=1719903031258",
  },
  {
    id: 3,
    title: "Boost Productivity",
    Heading:
      "Transform Customer Support and Drive Operational Excellence with Microsoft support ticket system",
    content: (
      <ul>
        <li>
          Microsoft ticketing system software enhances customer service by
          providing insightful reports to gauge satisfaction and optimize team
          performance.
        </li>
        <li>
          It uncovers actionable insights for immediate improvements, ensuring a
          seamless experience for both teams and clients.
        </li>
        <li>
          Automated ticketing and workflow management streamline support
          processes, reducing response times and increasing efficiency.
        </li>
        <li>
          Customizable dashboards and metrics allow for tailored performance
          tracking and reporting to meet specific business needs.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/boast_xwE5iohIU.gif?updatedAt=1719904751386",
  },
  {
    id: 4,
    title: "Rules and Automation",
    Heading: "Drive Efficiency with Customized Rules and Automation",
    content: (
      <ul>
        <li>
          Boost operational efficiency with Apps365’s 'Rule & Automation'
          feature. Customize and automate ticket management by creating advanced
          rules for generating, assigning, and routing tickets based on your
          needs.
        </li>
        <li>
          This feature streamlines ITSM operations, ensures prompt attention to
          every ticket, and saves valuable time and resources.
        </li>
        <li>
          Automated escalation protocols ensure critical issues receive
          immediate attention, reducing resolution times for high-priority
          tickets.
        </li>
        <li>
          Flexible rule configuration allows for dynamic adjustments to
          workflows, adapting to changing operational requirements and
          priorities.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Rules&automation_qYBfGojFe.gif?updatedAt=1719903031561",
  },
];

export const Helpdesk4FAQs = [
  {
    title: " How do I create a ticket in Microsoft?",
    content: (
      <ul>
        To create a ticket in Microsoft Helpdesk 365:
        <li>Open Microsoft Teams and go to the Helpdesk 365 app.</li>
        <li>Click New Ticket to start.</li>
        <li>
          Fill in the details, including the issue, priority, and any
          attachments.
        </li>
        <li>Submit the ticket, and it’s instantly logged.</li>
        You can track updates and communicate with the support team directly in
        Teams.
      </ul>
    ),
  },
  {
    title: "Can you use Microsoft Teams as a SharePoient ticket system?",
    content:
      "Using Microsoft Teams as a SharePoint based ticketing system enables employees to get instant support and resolve issues faster. Both employees and the support team collaborate easily on the same platform, with the added benefit of 24/7 accessibility for continuous assistance.",
  },
  {
    title: "Is SharePoint a Ticketing System?",
    content: (
      <ul>
        SharePoint a collaboration platform for managing documents and workflows
        for millions of Microsoft 365 users. However, you can customize it for
        ticket tracking and effective communication using:
        <li>Lists: To log and track tickets.</li>
        <li>Workflows: For automating assignments and updates.</li>
        <li>Power Automate: For advanced automation.</li>
        For a more robust ticketing solution, tools like Helpdesk 365 integrate
        seamlessly with SharePoint. So that you can easily manage your
        SharePoint ticketing system with more efficiency.
      </ul>
    ),
  },
  {
    title: "What is a SharePoint system?",
    content:
      "SharePoint is a web-based platform that improves your organization efficiency by simplifying data management and access. SharePoint serves as an enterprise information hub, easily customizable to support intranet, extranet, and internet sites.",
  },
  // {
  //   title: "Which Tools is SharePoint?",
  //   content:
  //     "Organizations use Microsoft SharePoint to create websites. You can use it as a secure place to store, organize, share, and access information from any device. All you need is a web browser, such as Microsoft Edge, Internet Explorer, Chrome, or Firefox. Want to learn more?",
  // },
];

//5th Page /microsoft-ticketing-system

export const Helpdesk5FirstSection = {
  MainHeading:
    "Smarter Support, Happier Teams – Faster Ticketing with Helpdesk 365",
  MainDescription:
    "Manage tickets easily with our Microsoft ticketing system that works perfectly with Microsoft 365. Help your team give faster and better support without any hassle.",
  MainImageAlt: "Helpdesk 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/Helpdesk_OjlohM6cD.png",
};

export const hd5tab1 = [
  {
    id: 1,
    title: "Focus on what you need",
    Heading:
      "Prioritize What Truly Matters: Simplify with Azure DevOps Ticket System",
    content: (
      <ul>
        <li>
          Simplify ticket management with Azure DevOps support ticket system
          that organizes tickets by priority, category, time, and status.
        </li>
        <li>
          Effortless request submission through the SharePoint portal via email
          or an embedded web part.
        </li>
        <li>
          Seamless collaboration with Microsoft Teams integration, offering
          conversational support for your team.
        </li>
        <li>
          Boost productivity and satisfaction by streamlining request tracking
          across IT, HR, and other departments.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Recording4-ezgif.com-video-to-gif-converter_1t1BQO-ac.gif?updatedAt=1718713728955",
  },
 {
    id: 2,
    title: "Ticket Management",
    Heading:
      "AI-Powered Ticket Management Features",
    content: (
      <ul>
        <li>
          {" "}
          Seamlessly manage tickets inside Microsoft Teams for faster collaboration. 
        </li>
        <li>
          {" "}
         AI-powered automation routes issues to the right agent instantly for rapid, accurate resolution. 
        </li>
        <li>
          {" "}
         Streamline workflows: auto-assign, track, and close tickets effortlessly. 
        </li>
        <li>
          Leverage Copilot to get real-time suggestions, auto-draft responses, and streamline support tasks—directly within your ticketing system.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/TicketManagement_NawCmGYkO.gif?updatedAt=1719903031399",
  },
  {
    id: 3,
    title: "SLA on cloud-based ",
    Heading: "Improve Efficiency with SLAs in Our Microsoft Ticketing System",
    content: (
      <ul><li>
          Make service delivery smoother and more dependable with HR365’s IT
        ticketing system—designed to keep both your team and customers happy.
      </li>
        
        <li>
          {" "}
          Reliable Service with SLAs: Count on consistent support and keep
          customers satisfied with strong Service Level Agreements (SLAs).
        </li>
        <li>
          {" "}
          Actionable Insights: Use detailed reports and analytics to spot
          performance gaps and improve your service.
        </li>
        <li>
          Timely Responses: Automated SLA tracking and alerts help your team
          stay on top, ensuring quick responses and fast issue resolution.
        </li>
        <li>
          Tailored to Your Needs: Customize SLA templates to create service
          levels that fit your organization’s goals perfectly.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/SLA_SKQ5cy1rQf.gif?updatedAt=1719814962251",
  },
  {
    id: 4,
    title: "Easy Customization",
    Heading:
      "Azure DevOps Ticketing System Work Perfectly for You with Easy Customization",
    content: (
      <ul>
        <li>
          Improve your support experience with our flexible Azure DevOps
          Ticketing system, seamlessly integrated with SharePoint.
        </li>
        <li>
          {" "}
          Easily assign tickets, prioritize tasks, and keep everyone updated
          with streamlined notifications.
        </li>
        <li>
          Boosts productivity, streamlines workflows, and speeds up response
          times, creating a supportive environment that goes above and beyond.
        </li>
        <li>
          {" "}
          Advanced reporting and analytics help you spot trends and improve team
          performance for continuous growth.
        </li>
        <li>
          Integration with Microsoft Teams allows your support staff to
          collaborate and communicate in real-time, solving issues faster.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/approve_Q5cb5xjOH.gif?updatedAt=1719898618060",
  },
];
export const hd5tab2 = [
  {
    id: 1,
    title: " Support Experience ",
    Heading:
      "Transform Your Support with Cutting-edge Azure DevOps Ticket System Features",
    content: (
      <ul>
        <li>
          Empower customer support with our comprehensive ticketing system,
          boosting productivity.
        </li>
        <li>
          Clients can easily request tickets and get instant status updates
          through our intuitive platform.
        </li>
        <li>
          The SharePoint ticketing system not only tracks tickets but also helps
          identify solutions, with quick access to historical data and a
          knowledge base, accelerating issue resolution and reducing new ticket
          submissions.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Supportexp_eht3Bt82e6.gif?updatedAt=1719903031166",
  },
  {
    id: 2,
    title: "Security Measures",
    Heading: " Enhanced Security for Identity and Access Management",
    content: (
      <ul>
        <li>
          Azure ticket tracking system ensures security with robust identity and
          access management. Integrated with Microsoft 365, it employs a safe
          strategy with multiple security layers.
        </li>
        <li>
          These measures, along with stringent practices, protect your Microsoft
          ticketing system against threats and unauthorized access. For detailed
          insights into our security protocols, contact Apps365.
        </li>
        <li>
          Regular security updates and vulnerability assessments ensure ongoing
          protection and adaptation to emerging threats.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Securitymeasures_SLoTGlIE5.gif?updatedAt=1719903031258",
  },
  {
    id: 3,
    title: "Boost Productivity",
    Heading:
      "Transform Customer Support and Drive Operational Excellence with Microsoft support ticket system",
    content: (
      <ul>
        <li>
          Microsoft ticketing system software enhances customer service by
          providing insightful reports to gauge satisfaction and optimize team
          performance.
        </li>
        <li>
          It uncovers actionable insights for immediate improvements, ensuring a
          seamless experience for both teams and clients.
        </li>
        <li>
          Automated ticketing and workflow management streamline support
          processes, reducing response times and increasing efficiency.
        </li>
        <li>
          Customizable dashboards and metrics allow for tailored performance
          tracking and reporting to meet specific business needs.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/boast_xwE5iohIU.gif?updatedAt=1719904751386",
  },
  {
    id: 4,
    title: "Rules and Automation",
    Heading: "Drive Efficiency with Customized Rules and Automation",
    content: (
      <ul>
        <li>
          Boost operational efficiency with Apps365’s 'Rule & Automation'
          feature. Customize and automate ticket management by creating advanced
          rules for generating, assigning, and routing tickets based on your
          needs.
        </li>
        <li>
          This feature streamlines ITSM operations, ensures prompt attention to
          every ticket, and saves valuable time and resources.
        </li>
        <li>
          Automated escalation protocols ensure critical issues receive
          immediate attention, reducing resolution times for high-priority
          tickets.
        </li>
        <li>
          Flexible rule configuration allows for dynamic adjustments to
          workflows, adapting to changing operational requirements and
          priorities.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Rules&automation_qYBfGojFe.gif?updatedAt=1719903031561",
  },
];

export const Helpdesk5FAQs = [
  {
    title: "How do I create a Small Business Ticketing System?",
    content: (
      <ul>
        To create a ticket in helpdesk Microsoft teams:
        <li>Open Microsoft Teams and go to the Helpdesk 365 app.</li>
        <li>Click New Ticket to start.</li>
        <li>
          Fill in the details, including the issue, priority, and any
          attachments.
        </li>
        <li>Submit the ticket, and it’s instantly logged.</li>
        You can track updates and communicate with the support team directly in
        Teams.
      </ul>
    ),
  },
  {
    title: "Helpdesk 365 v/s Desk365?",
    content: (
      <ul>
        <li>
          Helpdesk 365: Ideal for mid-sized to large organizations requiring
          advanced ticketing, automation, and analytics across IT and business
          departments.
        </li>
        <li>
          Desk365: Tailored for smaller teams and businesses looking for a
          lightweight, straightforward helpdesk solution with strong Microsoft
          Teams integration.
        </li>
        Both help desk applications are aligned towards customer and internal
        ticketing solutions but Helpdesk 365 wins by its easy to use usability
        and tailored made solutions for any size of business.
      </ul>
    ),
  },
  {
    title: "Is SharePoint a Ticketing System?",
    content: (
      <ul>
        SharePoint a collaboration platform for managing documents and workflows
        for millions of Microsoft 365 users. However, you can customize it for
        ticket tracking and effective communication using:
        <li>Lists: To log and track tickets.</li>
        <li>Workflows: For automating assignments and updates.</li>
        <li>Power Automate: For advanced automation.</li>
        For a more robust ticketing solution, tools like Helpdesk 365 integrate
        seamlessly with SharePoint. So that you can easily manage your
        SharePoint ticketing system with more efficiency.
      </ul>
    ),
  },
  {
    title: "What is a SharePoint system?",
    content:
      "SharePoint is a web-based platform that improves your organization efficiency by simplifying data management and access. SharePoint serves as an enterprise information hub, easily customizable to support intranet, extranet, and internet sites.",
  },
];

//6th Page "/azure-devops-ticketing-system",

export const Helpdesk6FirstSection = {
  MainHeading:
    "Smarter Support, Happier Teams – Faster Ticketing with Helpdesk 365",
  MainDescription:
    "Manage tickets easily with our Microsoft ticketing system that works perfectly with Microsoft 365. Help your team give faster and better support without any hassle.",
  MainImageAlt: "Helpdesk 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/Helpdesk_OjlohM6cD.png",
};

export const Helpdesk6FAQs = [
  {
    title: "How do I create a Helpdesk Ticketing System?",
    content: (
      <ul>
        To create a ticket in helpdesk Microsoft teams:
        <li>Open Microsoft Teams and go to the Helpdesk 365 app.</li>
        <li>Click New Ticket to start.</li>
        <li>
          Fill in the details, including the issue, priority, and any
          attachments.
        </li>
        <li>Submit the ticket, and it’s instantly logged.</li>
        You can track updates and communicate with the support team directly in
        Teams.
      </ul>
    ),
  },
  {
    title: "Helpdesk 365 v/s Desk365?",
    content: (
      <ul>
        <li>
          Helpdesk 365: Ideal for mid-sized to large organizations requiring
          advanced ticketing, automation, and analytics across IT and business
          departments.
        </li>
        <li>
          Desk365: Tailored for smaller teams and businesses looking for a
          lightweight, straightforward helpdesk solution with strong Microsoft
          Teams integration.
        </li>
        Both help desk applications are aligned towards customer and internal
        ticketing solutions but Helpdesk 365 wins by its easy to use usability
        and tailored made solutions for any size of business.
      </ul>
    ),
  },
  {
    title: "Is SharePoint a Ticketing System?",
    content: (
      <ul>
        SharePoint a collaboration platform for managing documents and workflows
        for millions of Microsoft 365 users. However, you can customize it for
        ticket tracking and effective communication using:
        <li>Lists: To log and track tickets.</li>
        <li>Workflows: For automating assignments and updates.</li>
        <li>Power Automate: For advanced automation.</li>
        For a more robust ticketing solution, tools like Helpdesk 365 integrate
        seamlessly with SharePoint. So that you can easily manage your
        SharePoint ticketing system with more efficiency.
      </ul>
    ),
  },
  {
    title: "What is a SharePoint system?",
    content:
      "SharePoint is a web-based platform that improves your organization efficiency by simplifying data management and access. SharePoint serves as an enterprise information hub, easily customizable to support intranet, extranet, and internet sites.",
  },
];

export const hd6tab1 = [
  {
    id: 1,
    title: "Focus on what you need",
    Heading: "Prioritize What Truly Matters: Simplify with HR Service Desk",
    content: (
      <ul>
        <li>
          {" "}
          Simplify ticket management with internal support ticket system that
          organizes tickets by priority, category, time, and status.
        </li>
        <li>
          Effortless request submission through the SharePoint portal via email
          or an embedded web part.
        </li>
        <li>
          Seamless collaboration with Microsoft Teams integration, offering
          conversational support for your team.
        </li>
        <li>
          Boost productivity and satisfaction by streamlining request tracking
          across IT, HR, and other departments.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Recording4-ezgif.com-video-to-gif-converter_1t1BQO-ac.gif?updatedAt=1718713728955",
  },
  {
    id: 2,
    title: "Ticket Management",
    Heading:
      "AI-Powered Ticket Management Features",
    content: (
      <ul>
        <li>
          {" "}
          Seamlessly integrate with Azure DevOps to enhance tracking, collaboration, and support workflow efficiency. 
        </li>
        <li>
          {" "}
          Predict risks in advance with proactive issue prediction to prevent escalations.
        </li>
        <li>
          {" "}
          Securely manage all tickets within Microsoft 365 ecosystem.  
        </li>
        <li>
          Prioritize, assign, and escalate tickets with SLA-driven automations. Automated routing improves team coordination. 
        </li>
        <li>
          Leverage Copilot to get real-time suggestions, auto-draft responses, and streamline support tasks—directly within your ticketing system.  
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/TicketManagement_NawCmGYkO.gif?updatedAt=1719903031399",
  },
  {
    id: 3,
    title: "SLA on cloud-based ",
    Heading: "Improve Efficiency with SLAs in Our Ticketing System App",
    content: (
      <ul>
        Make service delivery smoother and more dependable with HR365’s business
        ticketing system—designed to keep both your team and customers happy.
        <li>
          {" "}
          Reliable Service with SLAs: Count on consistent support and keep
          customers satisfied with strong Service Level Agreements (SLAs).
        </li>
        <li>
          {" "}
          Actionable Insights: Use detailed reports and analytics to spot
          performance gaps and improve your service.
        </li>
        <li>
          Timely Responses: Automated SLA tracking and alerts help your team
          stay on top, ensuring quick responses and fast issue resolution.
        </li>
        <li>
          Tailored to Your Needs: Customize SLA templates to create service
          levels that fit your organization’s goals perfectly.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/SLA_SKQ5cy1rQf.gif?updatedAt=1719814962251",
  },
  {
    id: 4,
    title: "Easy Customization",
    Heading:
      "Simple Ticketing System Work Perfectly for You with Easy Customization",
    content: (
      <ul>
        <li>
          Improve your support experience with our flexible ticketing management
          system, seamlessly integrated with SharePoint.
        </li>
        <li>
          {" "}
          Easily assign tickets, prioritize tasks, and keep everyone updated
          with streamlined notifications.
        </li>
        <li>
          Boosts productivity, streamlines workflows, and speeds up response
          times, creating a supportive environment that goes above and beyond.
        </li>
        <li>
          {" "}
          Advanced reporting and analytics help you spot trends and improve team
          performance for continuous growth.
        </li>
        <li>
          Integration with Microsoft Teams allows your support staff to
          collaborate and communicate in real-time, solving issues faster.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/approve_Q5cb5xjOH.gif?updatedAt=1719898618060",
  },
];
export const hd6tab2 = [
  {
    id: 1,
    title: " Support Experience ",
    Heading:
      "Transform Your Support with Cutting-edge Employee Help Desk Features",
    content: (
      <ul>
        <li>
          Empower customer support with our comprehensive ticketing system,
          boosting productivity.
        </li>
        <li>
          Clients can easily request tickets and get instant status updates
          through our intuitive platform.
        </li>
        <li>
          The SharePoint ticketing system not only tracks tickets but also helps
          identify solutions, with quick access to historical data and a
          knowledge base, accelerating issue resolution and reducing new ticket
          submissions.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Supportexp_eht3Bt82e6.gif?updatedAt=1719903031166",
  },
  {
    id: 2,
    title: "Security Measures",
    Heading: " Enhanced Security for Identity and Access Management",
    content: (
      <ul>
        <li>
          Azure ticket tracking system ensures security with robust identity and
          access management. Integrated with Microsoft 365, it employs a safe
          strategy with multiple security layers.
        </li>
        <li>
          These measures, along with stringent practices, protect your Microsoft
          ticketing system against threats and unauthorized access. For detailed
          insights into our security protocols, contact Apps365.
        </li>
        <li>
          Regular security updates and vulnerability assessments ensure ongoing
          protection and adaptation to emerging threats.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Securitymeasures_SLoTGlIE5.gif?updatedAt=1719903031258",
  },
  {
    id: 3,
    title: "Boost Productivity",
    Heading:
      "Transform Customer Support and Drive Operational Excellence with Helpdesk Ticketing System",
    content: (
      <ul>
        <li>
          Ticket system support enhances customer service by providing
          insightful reports to gauge satisfaction and optimize team
          performance.
        </li>
        <li>
          It uncovers actionable insights for immediate improvements, ensuring a
          seamless experience for both teams and clients.
        </li>
        <li>
          Automated ticketing and workflow management streamline support
          processes, reducing response times and increasing efficiency.
        </li>
        <li>
          Customizable dashboards and metrics allow for tailored performance
          tracking and reporting to meet specific business needs.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/boast_xwE5iohIU.gif?updatedAt=1719904751386",
  },
  {
    id: 4,
    title: "Rules and Automation",
    Heading: "Drive Efficiency with Customized Rules and Automation",
    content: (
      <ul>
        <li>
          Boost operational efficiency with Apps365’s 'Rule & Automation'
          feature. Customize and automate ticket management by creating advanced
          rules for generating, assigning, and routing tickets based on your
          needs.
        </li>
        <li>
          This feature streamlines ITSM operations, ensures prompt attention to
          every ticket, and saves valuable time and resources.
        </li>
        <li>
          Automated escalation protocols ensure critical issues receive
          immediate attention, reducing resolution times for high-priority
          tickets.
        </li>
        <li>
          Flexible rule configuration allows for dynamic adjustments to
          workflows, adapting to changing operational requirements and
          priorities.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Rules&automation_qYBfGojFe.gif?updatedAt=1719903031561",
  },
];

//7th Page "/helpdesk-ticketing-system"

export const Helpdesk7FirstSection = {
  MainHeading:
    "Smarter Support, Happier Teams – Faster Ticketing with Helpdesk 365",
  MainDescription:
    "Manage tickets easily with our Helpdesk ticketing system that works perfectly with Microsoft 365. Help your team give faster and better support without any hassle.",
  MainImageAlt: "Helpdesk 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/Helpdesk_OjlohM6cD.png",
};

export const Helpdesk7FAQs = [
  {
    title: "How do I create a Helpdesk Ticketing System?",
    content: (
      <ul>
        To create a ticket in Microsoft teams
        <li>Open Microsoft Teams and go to the Helpdesk 365 app.</li>
        <li>Click New Ticket to start.</li>
        <li>
          Fill in the details, including the issue, priority, and any
          attachments.
        </li>
        <li>Submit the ticket, and it’s instantly logged.</li>
        You can track updates and communicate with the support team directly in
        Teams.
      </ul>
    ),
  },
  {
    title: "Is SharePoint a Ticketing System?",
    content: (
      <ul>
        SharePoint a collaboration platform for managing documents and workflows
        for millions of Microsoft 365 users. However, you can customize it for
        ticket tracking and effective communication using:
        <li>Lists: To log and track tickets.</li>
        <li>Workflows: For automating assignments and updates.</li>
        <li>Power Automate: For advanced automation.</li>
        For a more robust ticketing solution, tools like Helpdesk 365 integrate
        seamlessly with SharePoint. So that you can easily manage your
        SharePoint ticketing system with more efficiency.
      </ul>
    ),
  },
  {
    title: "What is SharePoint Ticket System?",
    content:
      "SharePoint is a web-based platform that improves your organization efficiency by simplifying data management and access. SharePoint serves as an enterprise information hub, easily customizable to support intranet, extranet, and internet sites.",
  },
];

export const hd7tab1 = [
  {
    id: 1,
    title: "Focus on what you need",
    Heading: "Prioritize What Truly Matters: Simplify with HR Service Desk",
    content: (
      <ul>
        <li>
          {" "}
          Simplify ticket management with internal support ticket system that
          organizes tickets by priority, category, time, and status.
        </li>
        <li>
          Effortless request submission through the SharePoint portal via email
          or an embedded web part.
        </li>
        <li>
          Seamless collaboration with Microsoft Teams integration, offering
          conversational support for your team.
        </li>
        <li>
          Boost productivity and satisfaction by streamlining request tracking
          across IT, HR, and other departments.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Recording4-ezgif.com-video-to-gif-converter_1t1BQO-ac.gif?updatedAt=1718713728955",
  },
  {
    id: 2,
    title: "Ticket Management",
    Heading:
      "AI-Powered Ticket Management Features",
    content: (
      <ul>
        <li>
          {" "}
          Seamlessly manage tickets inside Microsoft Teams for faster collaboration. 
        </li>
        <li>
          {" "}
          AI-powered automation routes issues to the right agent instantly for rapid, accurate resolution. 
        </li>
        <li>
          {" "}
          Streamline workflows: auto-assign, track, and close tickets effortlessly. 
        </li>
        <li>
          {" "}
         Leverage Copilot to get real-time suggestions, auto-draft responses, and streamline support tasks—directly within your ticketing system. 
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/TicketManagement_NawCmGYkO.gif?updatedAt=1719903031399",
  },
  {
    id: 3,
    title: "SLA on cloud-based ",
    Heading: "Improve Efficiency with SLAs in Our Ticketing System App",
    content: (
      <ul>
        Make service delivery smoother and more dependable with HR365’s business
        ticketing system—designed to keep both your team and customers happy.
        <li>
          {" "}
          Reliable Service with SLAs: Count on consistent support and keep
          customers satisfied with strong Service Level Agreements (SLAs).
        </li>
        <li>
          {" "}
          Actionable Insights: Use detailed reports and analytics to spot
          performance gaps and improve your service.
        </li>
        <li>
          Timely Responses: Automated SLA tracking and alerts help your team
          stay on top, ensuring quick responses and fast issue resolution.
        </li>
        <li>
          Tailored to Your Needs: Customize SLA templates to create service
          levels that fit your organization’s goals perfectly.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/SLA_SKQ5cy1rQf.gif?updatedAt=1719814962251",
  },
  {
    id: 4,
    title: "Easy Customization",
    Heading:
      "Simple Ticketing System Work Perfectly for You with Easy Customization",
    content: (
      <ul>
        <li>
          Improve your support experience with our flexible ticketing management
          system, seamlessly integrated with SharePoint.
        </li>
        <li>
          Easily assign tickets, prioritize tasks, and keep everyone updated
          with streamlined notifications.
        </li>
        <li>
          Boosts productivity, streamlines workflows, and speeds up response
          times, creating a supportive environment that goes above and beyond.
        </li>
        <li>
          Advanced reporting and analytics help you spot trends and improve team
          performance for continuous growth.
        </li>
        <li>
          Integration with Microsoft Teams allows your support staff to
          collaborate and communicate in real-time, solving issues faster.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/approve_Q5cb5xjOH.gif?updatedAt=1719898618060",
  },
];
export const hd7tab2 = [
  {
    id: 1,
    title: " Support Experience ",
    Heading:
      "Transform Your Support with Cutting-edge Employee Help Desk Features",
    content: (
      <ul>
        <li>
          Empower customer support with our comprehensive ticketing system,
          boosting productivity.
        </li>
        <li>
          Clients can easily request tickets and get instant status updates
          through our intuitive platform.
        </li>
        <li>
          The SharePoint ticketing system not only tracks tickets but also helps
          identify solutions, with quick access to historical data and a
          knowledge base, accelerating issue resolution and reducing new ticket
          submissions.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Supportexp_eht3Bt82e6.gif?updatedAt=1719903031166",
  },
  {
    id: 2,
    title: "Security Measures",
    Heading: " Enhanced Security for Identity and Access Management",
    content: (
      <ul>
        <li>
          Azure ticket tracking system ensures security with robust identity and
          access management. Integrated with Microsoft 365, it employs a safe
          strategy with multiple security layers.
        </li>
        <li>
          These measures, along with stringent practices, protect your Microsoft
          ticketing system against threats and unauthorized access. For detailed
          insights into our security protocols, contact Apps365.
        </li>
        <li>
          Regular security updates and vulnerability assessments ensure ongoing
          protection and adaptation to emerging threats.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Securitymeasures_SLoTGlIE5.gif?updatedAt=1719903031258",
  },
  {
    id: 3,
    title: "Boost Productivity",
    Heading:
      "Transform Customer Support and Drive Operational Excellence with Helpdesk Ticketing System",
    content: (
      <ul>
        <li>
          Ticket system support enhances customer service by providing
          insightful reports to gauge satisfaction and optimize team
          performance.
        </li>
        <li>
          It uncovers actionable insights for immediate improvements, ensuring a
          seamless experience for both teams and clients.
        </li>
        <li>
          Automated ticketing and workflow management streamline support
          processes, reducing response times and increasing efficiency.
        </li>
        <li>
          Customizable dashboards and metrics allow for tailored performance
          tracking and reporting to meet specific business needs.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/boast_xwE5iohIU.gif?updatedAt=1719904751386",
  },
  {
    id: 4,
    title: "Rules and Automation",
    Heading: "Drive Efficiency with Customized Rules and Automation",
    content: (
      <ul>
        <li>
          Boost operational efficiency with Apps365’s 'Rule & Automation'
          feature. Customize and automate ticket management by creating advanced
          rules for generating, assigning, and routing tickets based on your
          needs.
        </li>
        <li>
          This feature streamlines ITSM operations, ensures prompt attention to
          every ticket, and saves valuable time and resources.
        </li>
        <li>
          Automated escalation protocols ensure critical issues receive
          immediate attention, reducing resolution times for high-priority
          tickets.
        </li>
        <li>
          Flexible rule configuration allows for dynamic adjustments to
          workflows, adapting to changing operational requirements and
          priorities.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Rules&automation_qYBfGojFe.gif?updatedAt=1719903031561",
  },
];

//page 8 /microsoft-365-ticketing-system"

export const Helpdesk8FirstSection = {
  MainHeading:
    "Smarter Support, Happier Teams – Faster Ticketing with Helpdesk 365",
  MainDescription:
    "Manage tickets easily with our Microsoft 365 ticketing system that works perfectly with Microsoft 365. Help your team give faster and better support without any hassle.",
  MainImageAlt: "Helpdesk 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/Helpdesk_OjlohM6cD.png",
};

export const Helpdesk8FAQs = [
  {
    title: "How do I create a Microsoft 365 ticketing system?",
    content: (
      <ul>
        To create a ticket in Microsoft office ticketing system:
        <li>Open Microsoft Teams and go to the Helpdesk 365 app.</li>
        <li>Click New Ticket to start.</li>
        <li>
          Fill in the details, including the issue, priority, and any
          attachments.
        </li>
        <li>Submit the ticket, and it’s instantly logged.</li>
        You can track updates and communicate with the support team directly in
        Teams.
      </ul>
    ),
  },
  {
    title: "Is SharePoint a Ticketing System?",
    content: (
      <ul>
        SharePoint a collaboration platform for managing documents and workflows
        for millions of Microsoft 365 users. However, you can customize it for
        ticket tracking and effective communication using:
        <li>Lists: To log and track tickets.</li>
        <li>Workflows: For automating assignments and updates.</li>
        <li>Power Automate: For advanced automation.</li>
        For a more robust ticketing solution, tools like Helpdesk 365 integrate
        seamlessly with SharePoint. So that you can easily manage your
        SharePoint ticketing system with more efficiency.
      </ul>
    ),
  },
  {
    title: "What is SharePoint Ticket System?",
    content:
      "SharePoint is a web-based platform that improves your organization efficiency by simplifying data management and access. SharePoint serves as an enterprise information hub, easily customizable to support intranet, extranet, and internet sites.",
  },
];

export const hd8tab1 = [
  {
    id: 1,
    title: "Focus on what you need",
    Heading:
      "Prioritize What Truly Matters: Simplify with Microsoft office ticketing system",
    content: (
      <ul>
        <li>
          Simplify ticket management with Microsoft ticketing system office 365
          that organizes tickets by priority, category, time, and status.
        </li>
        <li>
          Effortless request submission through the SharePoint portal via email
          or an embedded web part.
        </li>
        <li>
          Seamless collaboration with Microsoft Teams integration, offering
          conversational support for your team.
        </li>
        <li>
          Boost productivity and satisfaction by streamlining request tracking
          across IT, HR, and other departments.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Recording4-ezgif.com-video-to-gif-converter_1t1BQO-ac.gif?updatedAt=1718713728955",
  },
  {
    id: 2,
    title: "Ticket Management",
    Heading:
      "AI-Powered Ticket Management Features",
    content: (
      <ul>
        <li>
          {" "}
          Seamlessly manage tickets inside Microsoft Teams for faster collaboration. 
        </li>
        <li>
          {" "}
         AI-powered automation routes issues to the right agent instantly for rapid, accurate resolution. 
        </li>
        <li>
          {" "}
         Streamline workflows: auto-assign, track, and close tickets effortlessly. 
        </li>
        <li>
          Leverage Copilot to get real-time suggestions, auto-draft responses, and streamline support tasks—directly within your ticketing system
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/TicketManagement_NawCmGYkO.gif?updatedAt=1719903031399",
  },
  {
    id: 3,
    title: "SLA on cloud-based ",
    Heading: "Improve Efficiency with SLAs in Our Microsoft 365 Ticketing System",
    content: (
      <ul>
        Make service delivery smoother and more dependable with HR365’s
        Microsoft dynamics ticketing system —designed to keep both your team and
        customers happy.
        <li>
          Reliable Service with SLAs: Count on consistent support and keep
          customers satisfied with strong Service Level Agreements (SLAs).
        </li>
        <li>
          Actionable Insights: Use detailed reports and analytics to spot
          performance gaps and improve your service.
        </li>
        <li>
          Timely Responses: Automated SLA tracking and alerts help your team
          stay on top, ensuring quick responses and fast issue resolution.
        </li>
        <li>
          Tailored to Your Needs: Customize SLA templates to create service
          levels that fit your organization’s goals perfectly.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/SLA_SKQ5cy1rQf.gif?updatedAt=1719814962251",
  },
  {
    id: 4,
    title: "Easy Customization",
    Heading:
      "Powerapps ticketing system Work Perfectly for You with Easy Customization",
    content: (
      <ul>
        <li>
          Improve your support experience with our flexible Microsoft office 365
          ticketing system seamlessly integrated with SharePoint.
        </li>
        <li>
          Easily assign tickets, prioritize tasks, and keep everyone updated
          with streamlined notifications.
        </li>
        <li>
          Boosts productivity, streamlines workflows, and speeds up response
          times, creating a supportive environment that goes above and beyond.
        </li>
        <li>
          Advanced reporting and analytics help you spot trends and improve team
          performance for continuous growth.
        </li>
        <li>
          Integration with Microsoft Teams allows your support staff to
          collaborate and communicate in real-time, solving issues faster.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/approve_Q5cb5xjOH.gif?updatedAt=1719898618060",
  },
];
export const hd8tab2 = [
  {
    id: 1,
    title: " Support Experience ",
    Heading:
      "Transform Your Support with Cutting-edge Office 365 Ticketing System Features",
    content: (
      <ul>
        <li>
          Empower customer support with our comprehensive ticketing system,
          boosting productivity.
        </li>
        <li>
          Clients can easily request tickets and get instant status updates
          through our intuitive platform.
        </li>
        <li>
          The SharePoint ticketing system not only tracks tickets but also helps
          identify solutions, with quick access to historical data and a
          knowledge base, accelerating issue resolution and reducing new ticket
          submissions.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Supportexp_eht3Bt82e6.gif?updatedAt=1719903031166",
  },
  {
    id: 2,
    title: "Security Measures",
    Heading: " Enhanced Security for Identity and Access Management",
    content: (
      <ul>
        <li>
          Office 365 ticketing system ensures security with robust identity and
          access management. Integrated with Microsoft 365, it employs a safe
          strategy with multiple security layers.
        </li>
        <li>
          These measures, along with stringent practices, protect your Microsoft
          ticketing system against threats and unauthorized access. For detailed
          insights into our security protocols, contact Apps365.
        </li>
        <li>
          Regular security updates and vulnerability assessments ensure ongoing
          protection and adaptation to emerging threats.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Securitymeasures_SLoTGlIE5.gif?updatedAt=1719903031258",
  },
  {
    id: 3,
    title: "Boost Productivity",
    Heading:
      "Transform Customer Support and Drive Operational Excellence with o365 ticketing system",
    content: (
      <ul>
        <li>
          Ticket system support enhances customer service by providing
          insightful reports to gauge satisfaction and optimize team
          performance.
        </li>
        <li>
          It uncovers actionable insights for immediate improvements, ensuring a
          seamless experience for both teams and clients.
        </li>
        <li>
          Automated ticketing and workflow management streamline support
          processes, reducing response times and increasing efficiency.
        </li>
        <li>
          Customizable dashboards and metrics allow for tailored performance
          tracking and reporting to meet specific business needs.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/boast_xwE5iohIU.gif?updatedAt=1719904751386",
  },
  {
    id: 4,
    title: "Rules and Automation",
    Heading: "Drive Efficiency with Customized Rules and Automation",
    content: (
      <ul>
        <li>
          Boost operational efficiency with Apps365’s 'Rule & Automation'
          feature. Customize and automate ticket management by creating advanced
          rules for generating, assigning, and routing tickets based on your
          needs.
        </li>
        <li>
          This feature streamlines ITSM operations, ensures prompt attention to
          every ticket, and saves valuable time and resources.
        </li>
        <li>
          Automated escalation protocols ensure critical issues receive
          immediate attention, reducing resolution times for high-priority
          tickets.
        </li>
        <li>
          Flexible rule configuration allows for dynamic adjustments to
          workflows, adapting to changing operational requirements and
          priorities.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Rules&automation_qYBfGojFe.gif?updatedAt=1719903031561",
  },
];

//Page 9 "/it-service-ticket-software"

export const Helpdesk9FirstSection = {
  MainHeading:
    "Smarter Support, Happier Teams – Faster Ticketing with Helpdesk 365",
  MainDescription:
    "Manage tickets easily with our IT service ticket software that works perfectly with Microsoft 365. Help your team give faster and better support without any hassle.",
  MainImageAlt: "Helpdesk 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/Helpdesk_OjlohM6cD.png",
};

export const Helpdesk9FAQs = [
  {
    title: "How do I create a IT service ticket software?",
    content: (
      <ul>
        To create a ticket in Microsoft office ticketing system:
        <li>Open Microsoft Teams and go to the Helpdesk 365 app.</li>
        <li>Click New Ticket to start.</li>
        <li>
          Fill in the details, including the issue, priority, and any
          attachments.
        </li>
        <li>Submit the ticket, and it’s instantly logged.</li>
        You can track updates and communicate with the support team directly in
        Teams.
      </ul>
    ),
  },
  {
    title: "Is SharePoint a Ticketing System?",
    content: (
      <ul>
        SharePoint a collaboration platform for managing documents and workflows
        for millions of Microsoft 365 users. However, you can customize it for
        ticket tracking and effective communication using:
        <li>Lists: To log and track tickets.</li>
        <li>Workflows: For automating assignments and updates.</li>
        <li>Power Automate: For advanced automation.</li>
        For a more robust ticketing solution, tools like Helpdesk 365 integrate
        seamlessly with SharePoint. So that you can easily manage your
        SharePoint ticketing system with more efficiency.
      </ul>
    ),
  },
  {
    title: "What is SharePoint Ticket System?",
    content:
      "SharePoint is a web-based platform that improves your organization efficiency by simplifying data management and access. SharePoint serves as an enterprise information hub, easily customizable to support intranet, extranet, and internet sites.",
  },
];

export const hd9tab1 = [
  {
    id: 1,
    title: "Focus on what you need",
    Heading:
      "Prioritize What Truly Matters: Simplify with our Ticket Management Software",
    content: (
      <ul>
        <li>
          Simplify ticket management with IT help desk ticket software that
          organizes tickets by priority, category, time, and status.
        </li>
        <li>
          Effortless request submission through the SharePoint portal via email
          or an embedded web part.
        </li>
        <li>
          Seamless collaboration with Microsoft Teams integration, offering
          conversational support for your team.
        </li>
        <li>
          Boost productivity and satisfaction by streamlining request tracking
          across IT, HR, and other departments.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Recording4-ezgif.com-video-to-gif-converter_1t1BQO-ac.gif?updatedAt=1718713728955",
  },
  {
    id: 2,
    title: "Ticket Management",
    Heading:
      "AI-Powered IT Ticket Management Features ",
    content: (
      <ul>
        <li>
          Automate IT request workflows—smart routing, auto close and auto-resolve built-in. 
        </li>
        <li>
          AI-Powered automation leverages AI to route tickets automatically, track issues, and suggest resolutions. 
        </li>
        <li>
          Automatic escalations ensure critical tickets always get top priority and auto-close tickets on confirmation to avoid backlog. 
        </li>
        <li>
          Work smarter with built-in Microsoft Copilot support—access helpful suggestions, automate responses, and boost efficiency.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/TicketManagement_NawCmGYkO.gif?updatedAt=1719903031399",
  },
  {
    id: 3,
    title: "SLA on cloud-based ",
    Heading: "Improve Efficiency with SLAs in Our Helpdesk Software",
    content: (
      <ul>
        Make service delivery smoother and more dependable with HR365’s IT
        ticket management software—designed to keep both your team and customers
        happy.
        <li>
          Reliable Service with SLAs: Count on consistent support and keep
          customers satisfied with strong Service Level Agreements (SLAs).
        </li>
        <li>
          Actionable Insights: Use detailed reports and analytics to spot
          performance gaps and improve your service.
        </li>
        <li>
          Timely Responses: Automated SLA tracking and alerts help your team
          stay on top, ensuring quick responses and fast issue resolution.
        </li>
        <li>
          Tailored to Your Needs: Customize SLA templates to create service
          levels that fit your organization’s goals perfectly.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/SLA_SKQ5cy1rQf.gif?updatedAt=1719814962251",
  },
  {
    id: 4,
    title: "Easy Customization",
    Heading:
      "Service Ticket Software Work Perfectly for You with Easy Customization",
    content: (
      <ul>
        <li>
          Improve your support experience with our flexible ticket management
          software seamlessly integrated with SharePoint.
        </li>
        <li>
          Easily assign tickets, prioritize tasks, and keep everyone updated
          with streamlined notifications.
        </li>
        <li>
          Boosts productivity, streamlines workflows, and speeds up response
          times, creating a supportive environment that goes above and beyond.
        </li>
        <li>
          Advanced reporting and analytics help you spot trends and improve team
          performance for continuous growth.
        </li>
        <li>
          Integration with Microsoft Teams allows your support staff to
          collaborate and communicate in real-time, solving issues faster.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/approve_Q5cb5xjOH.gif?updatedAt=1719898618060",
  },
];
export const hd9tab2 = [
  {
    id: 1,
    title: " Support Experience ",
    Heading:
      "Transform Your Support with Cutting-edge Enterprise Help desk Software Features",
    content: (
      <ul>
        <li>
          Empower customer support with our comprehensive ticketing system,
          boosting productivity.
        </li>
        <li>
          Clients can easily request tickets and get instant status updates
          through our intuitive platform.
        </li>
        <li>
          The SharePoint ticketing system not only tracks tickets but also helps
          identify solutions, with quick access to historical data and a
          knowledge base, accelerating issue resolution and reducing new ticket
          submissions.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Supportexp_eht3Bt82e6.gif?updatedAt=1719903031166",
  },
  {
    id: 2,
    title: "Security Measures",
    Heading: "Enhanced Security for Identity and Access Management",
    content: (
      <ul>
        <li>
          Our small business help desk software ensures security with robust
          identity and access management. Integrated with Microsoft 365, it
          employs a safe strategy with multiple security layers.
        </li>
        <li>
          These measures, along with stringent practices, protect your Microsoft
          ticketing system against threats and unauthorized access. For detailed
          insights into our security protocols, contact Apps365.
        </li>
        <li>
          Regular security updates and vulnerability assessments ensure ongoing
          protection and adaptation to emerging threats.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Securitymeasures_SLoTGlIE5.gif?updatedAt=1719903031258",
  },
  {
    id: 3,
    title: "Boost Productivity",
    Heading:
      "Transform Customer Support and Drive Operational Excellence with IT Help desk Ticketing System",
    content: (
      <ul>
        <li>
          Helpdesk ticket software enhances customer service by providing
          insightful reports to gauge satisfaction and optimize team
          performance.
        </li>
        <li>
          It uncovers actionable insights for immediate improvements, ensuring a
          seamless experience for both teams and clients.
        </li>
        <li>
          Automated ticketing and workflow management streamline support
          processes, reducing response times and increasing efficiency.
        </li>
        <li>
          Customizable dashboards and metrics allow for tailored performance
          tracking and reporting to meet specific business needs.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/boast_xwE5iohIU.gif?updatedAt=1719904751386",
  },
  {
    id: 4,
    title: "Rules and Automation",
    Heading: "Drive Efficiency with Customized Rules and Automation",
    content: (
      <ul>
        <li>
          Boost operational efficiency with Apps365’s 'Rule & Automation'
          feature. Customize and automate ticket management by creating advanced
          rules for generating, assigning, and routing tickets based on your
          needs.
        </li>
        <li>
          This feature streamlines ITSM operations, ensures prompt attention to
          every ticket, and saves valuable time and resources.
        </li>
        <li>
          Automated escalation protocols ensure critical issues receive
          immediate attention, reducing resolution times for high-priority
          tickets.
        </li>
        <li>
          Flexible rule configuration allows for dynamic adjustments to
          workflows, adapting to changing operational requirements and
          priorities.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Rules&automation_qYBfGojFe.gif?updatedAt=1719903031561",
  },
];

// Page 10  "/it-ticketing-system",

export const Helpdesk10FirstSection = {
  MainHeading:
    "Smarter Support, Happier Teams – Faster Ticketing with Helpdesk 365",
  MainDescription:
    "Manage tickets easily with our IT ticketing system that works perfectly with Microsoft 365. Help your team give faster and better support without any hassle.",
  MainImageAlt: "Helpdesk 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/Helpdesk_OjlohM6cD.png",
};

export const Helpdesk10FAQs = [
  {
    title: "How do I create a IT service ticket software?",
    content: (
      <ul>
        To create a ticket in Microsoft office ticketing system:
        <li>Open Microsoft Teams and go to the Helpdesk 365 app.</li>
        <li>Click New Ticket to start.</li>
        <li>
          Fill in the details, including the issue, priority, and any
          attachments.
        </li>
        <li>Submit the ticket, and it’s instantly logged.</li>
        You can track updates and communicate with the support team directly in
        Teams.
      </ul>
    ),
  },
  {
    title: "Is SharePoint a Ticketing System?",
    content: (
      <ul>
        SharePoint a collaboration platform for managing documents and workflows
        for millions of Microsoft 365 users. However, you can customize it for
        ticket tracking and effective communication using:
        <li>Lists: To log and track tickets.</li>
        <li>Workflows: For automating assignments and updates.</li>
        <li>Power Automate: For advanced automation.</li>
        For a more robust ticketing solution, tools like Helpdesk 365 integrate
        seamlessly with SharePoint. So that you can easily manage your
        SharePoint ticketing system with more efficiency.
      </ul>
    ),
  },
  {
    title: "What is SharePoint Ticket System?",
    content:
      "SharePoint is a web-based platform that improves your organization efficiency by simplifying data management and access. SharePoint serves as an enterprise information hub, easily customizable to support intranet, extranet, and internet sites.",
  },
];

export const hd10tab1 = [
  {
    id: 1,
    title: "Focus on what you need",
    Heading:
      "Prioritize What Truly Matters: Simplify with our IT Ticketing Software",
    content: (
      <ul>
        <li>
          Simplify ticket management with IT Ticket System that organizes
          tickets by priority, category, time, and status.
        </li>
        <li>
          Effortless request submission through the SharePoint portal via email
          or an embedded web part.
        </li>
        <li>
          Seamless collaboration with Microsoft Teams integration, offering
          conversational support for your team.
        </li>
        <li>
          Boost productivity and satisfaction by streamlining request tracking
          across IT, HR, and other departments.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Recording4-ezgif.com-video-to-gif-converter_1t1BQO-ac.gif?updatedAt=1718713728955",
  },
   {
    id: 2,
    title: "Ticket Management",
    Heading:
      "AI-Powered IT Ticket Management Features ",
    content: (
      <ul>
        <li>
          Automate IT request workflows—smart routing, auto close and auto-resolve built-in. 
        </li>
        <li>
          AI-Powered automation leverages AI to route tickets automatically, track issues, and suggest resolutions. 
        </li>
        <li>
          Automatic escalations ensure critical tickets always get top priority and auto-close tickets on confirmation to avoid backlog. 
        </li>
        <li>
          Work smarter with built-in Microsoft Copilot support—access helpful suggestions, automate responses, and boost efficiency.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/TicketManagement_NawCmGYkO.gif?updatedAt=1719903031399",
  },
  {
    id: 3,
    title: "SLA on cloud-based ",
    Heading: "Improve Efficiency with SLAs in Our IT Ticketing System",
    content: (
      <ul>
        Make service delivery smoother and more dependable with HR365’s IT
        ticketing tool—designed to keep both your team and customers happy.
        <li>
          Reliable Service with SLAs: Count on consistent support and keep
          customers satisfied with strong Service Level Agreements (SLAs).
        </li>
        <li>
          Actionable Insights: Use detailed reports and analytics to spot
          performance gaps and improve your service.
        </li>
        <li>
          Timely Responses: Automated SLA tracking and alerts help your team
          stay on top, ensuring quick responses and fast issue resolution.
        </li>
        <li>
          Tailored to Your Needs: Customize SLA templates to create service
          levels that fit your organization’s goals perfectly.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/SLA_SKQ5cy1rQf.gif?updatedAt=1719814962251",
  },
  {
    id: 4,
    title: "Easy Customization",
    Heading:
      "IT Help Desk Solution Work Perfectly for You with Easy Customization",
    content: (
      <ul>
        <li>
          Improve your support experience with our flexible IT Service Desk
          System seamlessly integrated with SharePoint.
        </li>
        <li>
          Easily assign tickets, prioritize tasks, and keep everyone updated
          with streamlined notifications.
        </li>
        <li>
          Boosts productivity, streamlines workflows, and speeds up response
          times, creating a supportive environment that goes above and beyond.
        </li>
        <li>
          Advanced reporting and analytics help you spot trends and improve team
          performance for continuous growth.
        </li>
        <li>
          Integration with Microsoft Teams allows your support staff to
          collaborate and communicate in real-time, solving issues faster.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/approve_Q5cb5xjOH.gif?updatedAt=1719898618060",
  },
];
export const hd10tab2 = [
  {
    id: 1,
    title: " Support Experience ",
    Heading: "Transform Your Support with Cutting-edge IT Ticketing Features",
    content: (
      <ul>
        <li>
          Empower customer support with our comprehensive ticketing system,
          boosting productivity.
        </li>
        <li>
          Clients can easily request tickets and get instant status updates
          through our intuitive platform.
        </li>
        <li>
          The SharePoint ticketing system not only tracks tickets but also helps
          identify solutions, with quick access to historical data and a
          knowledge base, accelerating issue resolution and reducing new ticket
          submissions.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Supportexp_eht3Bt82e6.gif?updatedAt=1719903031166",
  },
  {
    id: 2,
    title: "Security Measures",
    Heading: "Enhanced Security for Identity and Access Management",
    content: (
      <ul>
        <li>
          Internal IT ticketing system ensures security with robust identity and
          access management. Integrated with Microsoft 365, it employs a safe
          strategy with multiple security layers.
        </li>
        <li>
          These measures, along with stringent practices, protect your Microsoft
          ticketing system against threats and unauthorized access. For detailed
          insights into our security protocols, contact Apps365.
        </li>
        <li>
          Regular security updates and vulnerability assessments ensure ongoing
          protection and adaptation to emerging threats.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Securitymeasures_SLoTGlIE5.gif?updatedAt=1719903031258",
  },
  {
    id: 3,
    title: "Boost Productivity",
    Heading:
      "Transform Customer Support and Drive Operational Excellence with IT Ticketing System",
    content: (
      <ul>
        <li>
          IT ticketing software enhances customer service by providing
          insightful reports to gauge satisfaction and optimize team
          performance.
        </li>
        <li>
          It uncovers actionable insights for immediate improvements, ensuring a
          seamless experience for both teams and clients.
        </li>
        <li>
          Automated ticketing and workflow management streamline support
          processes, reducing response times and increasing efficiency.
        </li>
        <li>
          Customizable dashboards and metrics allow for tailored performance
          tracking and reporting to meet specific business needs.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/boast_xwE5iohIU.gif?updatedAt=1719904751386",
  },
  {
    id: 4,
    title: "Rules and Automation",
    Heading: "Drive Efficiency with Customized Rules and Automation",
    content: (
      <ul>
        <li>
          Boost operational efficiency with Apps365’s 'Rule & Automation'
          feature. Customize and automate ticket management by creating advanced
          rules for generating, assigning, and routing tickets based on your
          needs.
        </li>
        <li>
          This feature streamlines ITSM operations, ensures prompt attention to
          every ticket, and saves valuable time and resources.
        </li>
        <li>
          Automated escalation protocols ensure critical issues receive
          immediate attention, reducing resolution times for high-priority
          tickets.
        </li>
        <li>
          Flexible rule configuration allows for dynamic adjustments to
          workflows, adapting to changing operational requirements and
          priorities.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Rules&automation_qYBfGojFe.gif?updatedAt=1719903031561",
  },
];

//Page 11 "/sharepoint-helpdesk-software"

export const Helpdesk11FirstSection = {
  MainHeading:
    "Smarter Support, Happier Teams – Faster Ticketing with Helpdesk 365",
  MainDescription:
    "Manage tickets easily with our IT ticketing system that works perfectly with Microsoft 365. Help your team give faster and better support without any hassle.",
  MainImageAlt: "Helpdesk 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/Helpdesk_OjlohM6cD.png",
};

export const Helpdesk11FAQs = [
  {
    title: "How do I create a IT service ticket software?",
    content: (
      <ul>
        To create a ticket in Microsoft office ticketing system:
        <li>Open Microsoft Teams and go to the Helpdesk 365 app.</li>
        <li>Click New Ticket to start.</li>
        <li>
          Fill in the details, including the issue, priority, and any
          attachments.
        </li>
        <li>Submit the ticket, and it’s instantly logged.</li>
        You can track updates and communicate with the support team directly in
        Teams.
      </ul>
    ),
  },
  {
    title: "Is SharePoint a Ticketing System?",
    content: (
      <ul>
        SharePoint a collaboration platform for managing documents and workflows
        for millions of Microsoft 365 users. However, you can customize it for
        ticket tracking and effective communication using:
        <li>Lists: To log and track tickets.</li>
        <li>Workflows: For automating assignments and updates.</li>
        <li>Power Automate: For advanced automation.</li>
        For a more robust ticketing solution, tools like Helpdesk 365 integrate
        seamlessly with SharePoint. So that you can easily manage your
        SharePoint ticketing system with more efficiency.
      </ul>
    ),
  },
  {
    title: "What is SharePoint Ticket System?",
    content:
      "SharePoint is a web-based platform that improves your organization efficiency by simplifying data management and access. SharePoint serves as an enterprise information hub, easily customizable to support intranet, extranet, and internet sites.",
  },
];

export const hd11tab1 = [
  {
    id: 1,
    title: "Focus on what you need",
    Heading:
      "Prioritize What Truly Matters: Simplify with our SharePoint based Helpdesk",
    content: (
      <ul>
        <li>
          Simplify ticket management with SharePoint help desk ticketing system
          that organizes tickets by priority, category, time, and status.
        </li>
        <li>
          Effortless request submission through the SharePoint portal via email
          or an embedded web part.
        </li>
        <li>
          Seamless collaboration with Microsoft Teams integration, offering
          conversational support for your team.
        </li>
        <li>
          Boost productivity and satisfaction by streamlining request tracking
          across IT, HR, and other departments.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Recording4-ezgif.com-video-to-gif-converter_1t1BQO-ac.gif?updatedAt=1718713728955",
  },
   {
    id: 2,
    title: "Ticket Management",
    Heading:
      "SharePoint-Based Ticket Management Features",
    content: (
      <ul>
        <li>
          {" "}
          Natively built on SharePoint for seamless ticket management. 
        </li>
        <li>
          {" "}
          Centralize ticket tracking and workflows natively inside SharePoint lists and sites. 
        </li>
        <li>
          {" "}
           Define clear service level agreements, set ticket priorities, and continuously track response and resolution times to ensure accountability. 
        </li>
        <li>
          Leverage Copilot to get real-time suggestions, auto-draft responses, and streamline support tasks—directly within your ticketing system. 
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/TicketManagement_NawCmGYkO.gif?updatedAt=1719903031399",
  },
  {
    id: 3,
    title: "SLA on cloud-based ",
    Heading: "Improve Efficiency with SLAs in Our SharePoint Helpdesk System",
    content: (
      <ul>
        Make service delivery smoother and more dependable with HR365’s
        SharePoint helpdesk ticket system—designed to keep both your team
        and customers happy.
        <li>
          Reliable Service with SLAs: Count on consistent support and keep
          customers satisfied with strong Service Level Agreements (SLAs).
        </li>
        <li>
          Actionable Insights: Use detailed reports and analytics to spot
          performance gaps and improve your service.
        </li>
        <li>
          Timely Responses: Automated SLA tracking and alerts help your team
          stay on top, ensuring quick responses and fast issue resolution.
        </li>
        <li>
          Tailored to Your Needs: Customize SLA templates to create service
          levels that fit your organization’s goals perfectly.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/SLA_SKQ5cy1rQf.gif?updatedAt=1719814962251",
  },
  {
    id: 4,
    title: "Easy Customization",
    Heading:
      "SharePoint Helpdesk System Work Perfectly for You with Easy Customization",
    content: (
      <ul>
        <li>
          Improve your support experience with our flexible SharePoint help desk
          ticket system seamlessly integrated with SharePoint.
        </li>
        <li>
          Easily assign tickets, prioritize tasks, and keep everyone updated
          with streamlined notifications.
        </li>
        <li>
          Boosts productivity, streamlines workflows, and speeds up response
          times, creating a supportive environment that goes above and beyond.
        </li>
        <li>
          Advanced reporting and analytics help you spot trends and improve team
          performance for continuous growth.
        </li>
        <li>
          Integration with Microsoft Teams allows your support staff to
          collaborate and communicate in real-time, solving issues faster.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/approve_Q5cb5xjOH.gif?updatedAt=1719898618060",
  },
];
export const hd11tab2 = [
  {
    id: 1,
    title: " Support Experience ",
    Heading:
      "Transform Your Support with Cutting-edge SharePoint Helpdesk Features",
    content: (
      <ul>
        <li>
          Empower customer support with our comprehensive ticketing system,
          boosting productivity.
        </li>
        <li>
          Clients can easily request tickets and get instant status updates
          through our intuitive platform.
        </li>
        <li>
          The SharePoint ticketing system not only tracks tickets but also helps
          identify solutions, with quick access to historical data and a
          knowledge base, accelerating issue resolution and reducing new ticket
          submissions.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Supportexp_eht3Bt82e6.gif?updatedAt=1719903031166",
  },
  {
    id: 2,
    title: "Security Measures",
    Heading: "Enhanced Security for Identity and Access Management",
    content: (
      <ul>
        <li>
          Internal IT ticketing system ensures security with robust identity and
          access management. Integrated with Microsoft 365, it employs a safe
          strategy with multiple security layers.
        </li>
        <li>
          These measures, along with stringent practices, protect your Microsoft
          ticketing system against threats and unauthorized access. For detailed
          insights into our security protocols, contact Apps365.
        </li>
        <li>
          Regular security updates and vulnerability assessments ensure ongoing
          protection and adaptation to emerging threats.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Securitymeasures_SLoTGlIE5.gif?updatedAt=1719903031258",
  },
  {
    id: 3,
    title: "Boost Productivity",
    Heading:
      "Transform Customer Support and Drive Operational Excellence with IT Ticketing System",
    content: (
      <ul>
        <li>
          IT ticketing software enhances customer service by providing
          insightful reports to gauge satisfaction and optimize team
          performance.
        </li>
        <li>
          It uncovers actionable insights for immediate improvements, ensuring a
          seamless experience for both teams and clients.
        </li>
        <li>
          Automated ticketing and workflow management streamline support
          processes, reducing response times and increasing efficiency.
        </li>
        <li>
          Customizable dashboards and metrics allow for tailored performance
          tracking and reporting to meet specific business needs.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/boast_xwE5iohIU.gif?updatedAt=1719904751386",
  },
  {
    id: 4,
    title: "Rules and Automation",
    Heading: "Drive Efficiency with Customized Rules and Automation",
    content: (
      <ul>
        <li>
          Boost operational efficiency with Apps365’s 'Rule & Automation'
          feature. Customize and automate ticket management by creating advanced
          rules for generating, assigning, and routing tickets based on your
          needs.
        </li>
        <li>
          This feature streamlines ITSM operations, ensures prompt attention to
          every ticket, and saves valuable time and resources.
        </li>
        <li>
          Automated escalation protocols ensure critical issues receive
          immediate attention, reducing resolution times for high-priority
          tickets.
        </li>
        <li>
          Flexible rule configuration allows for dynamic adjustments to
          workflows, adapting to changing operational requirements and
          priorities.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Rules&automation_qYBfGojFe.gif?updatedAt=1719903031561",
  },
];

// Pages "/sharepoint-it-ticketing-system"

export const Helpdesk12FirstSection = {
  MainHeading:
    "Smarter Support, Happier Teams – Faster Ticketing with Helpdesk 365",
  MainDescription:
    "Manage tickets easily with our SharePoint Helpdesk that works perfectly with Microsoft 365. Help your team give faster and better support without any hassle.",
  MainImageAlt: "Helpdesk 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/Helpdesk_OjlohM6cD.png",
};

export const Helpdesk12FAQs = [
  {
    title: "How do I create a Microsoft 365 ticketing system?",
    content: (
      <ul>
        To create a ticket in Microsoft office ticketing system:
        <li>Open Microsoft Teams and go to the Helpdesk 365 app.</li>
        <li>Click New Ticket to start.</li>
        <li>
          Fill in the details, including the issue, priority, and any
          attachments.
        </li>
        <li>Submit the ticket, and it’s instantly logged.</li>
        You can track updates and communicate with the support team directly in
        Teams.
      </ul>
    ),
  },
  {
    title: "Is SharePoint a Ticketing System?",
    content: (
      <ul>
        SharePoint a collaboration platform for managing documents and workflows
        for millions of Microsoft 365 users. However, you can customize it for
        ticket tracking and effective communication using:
        <li>Lists: To log and track tickets.</li>
        <li>Workflows: For automating assignments and updates.</li>
        <li>Power Automate: For advanced automation.</li>
        For a more robust ticketing solution, tools like Helpdesk 365 integrate
        seamlessly with SharePoint. So that you can easily manage your
        SharePoint ticketing system with more efficiency.
      </ul>
    ),
  },
  {
    title: "What is SharePoint Ticket System?",
    content:
      "SharePoint is a web-based platform that improves your organization efficiency by simplifying data management and access. SharePoint serves as an enterprise information hub, easily customizable to support intranet, extranet, and internet sites.",
  },
];

export const hd12tab1 = [
  {
    id: 1,
    title: "Focus on what you need",
    Heading:
      "Prioritize What Truly Matters: Simplify with our SharePoint ticketing solution",
    content: (
      <ul>
        <li>
          Simplify ticket management with Microsoft SharePoint ticketing system
          that organizes tickets by priority, category, time, and status.
        </li>
        <li>
          Effortless request submission through the SharePoint portal via email
          or an embedded web part.
        </li>
        <li>
          Seamless collaboration with Microsoft Teams integration, offering
          conversational support for your team.
        </li>
        <li>
          Boost productivity and satisfaction by streamlining request tracking
          across IT, HR, and other departments.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Recording4-ezgif.com-video-to-gif-converter_1t1BQO-ac.gif?updatedAt=1718713728955",
  },
  {
    id: 2,
    title: "Ticket Management",
    Heading:
      "Effortless and Reliable SharePoint ticket tracking system Features You’ll Love",
    content: (
      <ul>
        <li>
          Easily find colleagues by name, department, skills, or custom details
          using powerful search and filtering options.
        </li>
        <li>
          Save time in large organizations with advanced search functions that
          improve collaboration and efficiency.
        </li>
        <li>
          Quick access to frequently used filters with saved search preferences
          and recent queries.
        </li>
        <li>
          Visualize team dynamics with organizational chart integration, showing
          clear reporting structures for better understanding.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/TicketManagement_NawCmGYkO.gif?updatedAt=1719903031399",
  },
  {
    id: 3,
    title: "SLA on cloud-based ",
    Heading:
      "Improve Efficiency with SLAs in Our SharePoint Online Ticketing Systems",
    content: (
      <ul>
        Make service delivery smoother and more dependable with HR365’s
        SharePoint email ticketing system —designed to keep both your team and
        customers happy.
        <li>
          Reliable Service with SLAs: Count on consistent support and keep
          customers satisfied with strong Service Level Agreements (SLAs).
        </li>
        <li>
          Actionable Insights: Use detailed reports and analytics to spot
          performance gaps and improve your service.
        </li>
        <li>
          Timely Responses: Automated SLA tracking and alerts help your team
          stay on top, ensuring quick responses and fast issue resolution.
        </li>
        <li>
          Tailored to Your Needs: Customize SLA templates to create service
          levels that fit your organization’s goals perfectly.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/SLA_SKQ5cy1rQf.gif?updatedAt=1719814962251",
  },
  {
    id: 4,
    title: "Easy Customization",
    Heading:
      "Powerapps ticketing system Work Perfectly for You with Easy Customization",
    content: (
      <ul>
        <li>
          Improve your support experience with our flexible SharePoint IT
          ticketing system seamlessly integrated with SharePoint.
        </li>
        <li>
          Easily assign tickets, prioritize tasks, and keep everyone updated
          with streamlined notifications.
        </li>
        <li>
          Boosts productivity, streamlines workflows, and speeds up response
          times, creating a supportive environment that goes above and beyond.
        </li>
        <li>
          Advanced reporting and analytics help you spot trends and improve team
          performance for continuous growth.
        </li>
        <li>
          Integration with Microsoft Teams allows your support staff to
          collaborate and communicate in real-time, solving issues faster.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/approve_Q5cb5xjOH.gif?updatedAt=1719898618060",
  },
];
export const hd12tab2 = [
  {
    id: 1,
    title: " Support Experience ",
    Heading:
      "Transform Your Support with Cutting-edge SharePoint Ticketing Solution Features",
    content: (
      <ul>
        <li>
          Empower customer support with our comprehensive ticketing system,
          boosting productivity.
        </li>
        <li>
          Clients can easily request tickets and get instant status updates
          through our intuitive platform.
        </li>
        <li>
          The SharePoint ticketing system not only tracks tickets but also helps
          identify solutions, with quick access to historical data and a
          knowledge base, accelerating issue resolution and reducing new ticket
          submissions.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Supportexp_eht3Bt82e6.gif?updatedAt=1719903031166",
  },
  {
    id: 2,
    title: "Security Measures",
    Heading: "Enhanced Security for Identity and Access Management",
    content: (
      <ul>
        <li>
          Using SharePoint as a ticketing system ensures security with robust
          identity and access management. Integrated with Microsoft 365, it
          employs a safe strategy with multiple security layers.
        </li>
        <li>
          These measures, along with stringent practices, protect your Microsoft
          ticketing system against threats and unauthorized access. For detailed
          insights into our security protocols, contact Apps365.
        </li>
        <li>
          Regular security updates and vulnerability assessments ensure ongoing
          protection and adaptation to emerging threats.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Securitymeasures_SLoTGlIE5.gif?updatedAt=1719903031258",
  },
  {
    id: 3,
    title: "Boost Productivity",
    Heading:
      "Transform Customer Support and Drive Operational Excellence with SharePoint Ticketing System App",
    content: (
      <ul>
        <li>
          SharePoint ticketing system power automate enhances customer service
          by providing insightful reports to gauge satisfaction and optimize
          team performance.
        </li>
        <li>
          It uncovers actionable insights for immediate improvements, ensuring a
          seamless experience for both teams and clients.
        </li>
        <li>
          Automated ticketing and workflow management streamline support
          processes, reducing response times and increasing efficiency.
        </li>
        <li>
          Customizable dashboards and metrics allow for tailored performance
          tracking and reporting to meet specific business needs.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/boast_xwE5iohIU.gif?updatedAt=1719904751386",
  },
  {
    id: 4,
    title: "Rules and Automation",
    Heading: "Drive Efficiency with Customized Rules and Automation",
    content: (
      <ul>
        <li>
          Boost operational efficiency with Apps365’s 'Rule & Automation'
          feature. Customize and automate ticket management by creating advanced
          rules for generating, assigning, and routing tickets based on your
          needs.
        </li>
        <li>
          This feature streamlines ITSM operations, ensures prompt attention to
          every ticket, and saves valuable time and resources.
        </li>
        <li>
          Automated escalation protocols ensure critical issues receive
          immediate attention, reducing resolution times for high-priority
          tickets.
        </li>
        <li>
          Flexible rule configuration allows for dynamic adjustments to
          workflows, adapting to changing operational requirements and
          priorities.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/HD365/Rules&automation_qYBfGojFe.gif?updatedAt=1719903031561",
  },
];

//  ED365 Pages

//ED1 employee-directory"
export const ED1FirstSection = {
  MainHeading:
    "Easy Access, Stronger Teams – Improve Communication with Employee Directory 365",
  MainDescription:
    "Our modern Employee Directory is built-in with Microsoft 365 to help you gain easy access to team information and foster stronger communication across your organization.",
  MainImageAlt: "Employee Directory 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/ED365_sAcd5DKMg.png",
};

export const ED1FAQs = [
  {
    title: `How to Buy Best Employee Directory?`,
    content: `Buy best employee directory by focusing on your needs—key features, integrations, and budget—and exploring well-reviewed options. Test free trials, compare value and support, and pick a trusted provider that aligns with your goals. Employee Directory 365 can be customised as per your business infrastructure and needs.`,
  },
  {
    title: `Does Microsoft have an employee directory?`,
    content: (
      <ul>
        Microsoft 365 includes tools for an employee directory:
        <li>Microsoft Teams: Search for colleagues by name or department. </li>
        <li>Outlook: Use the Global Address List for contact details. </li>
        <li>
          Delve: Explore detailed profiles, org charts, and shared documents.{" "}
        </li>
        <li>Easy-to-use interface. </li>
        <li>Advanced search options. </li>
        <li>Seamless integration with Microsoft 365. </li>
        This makes managing and finding employees simple and efficient.
      </ul>
    ),
  },
  {
    title: `How to find SharePoint directory?`,
    content: (
      <ul>
        To find a directory in SharePoint, such as an employee or document
        directory, follow these steps:
        <li>
          Go to Your SharePoint Site: Open the SharePoint site where the
          directory is stored.{" "}
        </li>
        <li>
          Search in Site Contents:
          <li>
            Click the Settings gear icon (top-right corner) and select Site
            Contents.
          </li>
          <li>
            Look for a list or library named after the directory (e.g.,
            "Employee Directory").{" "}
          </li>
        </li>
        <li>
          Use the Search Bar:
          <li>Use the Search bar at the top of the SharePoint page. </li>
          <li>
            Enter keywords like "directory" or "employee directory" to locate it
            quickly.{" "}
          </li>
        </li>
        <li>
          Check for Links or Pages: Some directories might be displayed on a
          custom page or as a link in the site’s navigation menu.{" "}
        </li>
        <li>
          Ask the Admin: If you can’t find the directory, your SharePoint
          administrator can provide access or guidance.{" "}
        </li>
        This should help you locate the directory you need!
      </ul>
    ),
  },

  {
    title: `What is Employee Directory system?`,
    content: (
      <ul>
        Employee Directory system is a central hub where you can find
        information about everyone in your organization.
        <li>
          Basic Information: Names, job titles, departments, and contact details
          (phone, email, etc.).{" "}
        </li>
        <li>
          Organizational Structure: Reporting hierarchy and team associations.{" "}
        </li>
        <li>
          Profiles: Additional details like photos, work locations, and
          expertise.{" "}
        </li>
      </ul>
    ),
  },
];

export const ed1tab = [
  {
    id: 1,
    title: "Collaboration",
    Heading: "Simplify Collaboration with Employee Directory Software",
    content: (
      <ul>
        <li>Boost teamwork and efficiency with Employee Directory software.</li>
        <li>
          Seamlessly integrated with Microsoft 365, turning your directory into
          a central hub within SharePoint and Teams.
        </li>
        <li>
          Quick access to important employee details, reducing
          platform-switching and improving focus.{" "}
        </li>
        <li>
          Automatic updates ensure your employee information is always accurate
          and current across all platforms.{" "}
        </li>
        <li>
          Customizable search and filter options make it simple to find and
          connect with colleagues.{" "}
        </li>
        Empower your team to work smarter and stay connected with ease.
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Integration_J10FfNdpZB.gif?updatedAt=1720500232501",
  },
  {
    id: 2,
    title: "Features",
    Heading: "Enhanced Search Features of Employee Directory app",
    content: (
      <ul>
        <li>
          Easily find colleagues by name, department, skills, or custom details
          using powerful search and filtering options.{" "}
        </li>
        <li>
          Save time in large organizations with advanced search functions that
          improve collaboration and efficiency.{" "}
        </li>
        <li>
          Quick access to frequently used filters with saved search preferences
          and recent queries.{" "}
        </li>
        <li>
          Visualize team dynamics with organizational chart integration, showing
          clear reporting structures for better understanding.{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Searching_bszxfaq2js.gif?updatedAt=1720500232508",
  },
  {
    id: 3,
    title: "Visualization",
    Heading:
      "Interactive Organizational Visualizations in Teams Employee directory",
    content: (
      <ul>
        <li>
          Dynamic organizational charts that visually display company hierarchy
          and reporting lines.{" "}
        </li>
        <li>
          Interactive charts help team members understand roles and assist
          managers in improving team structures for better collaboration and
          planning.{" "}
        </li>
        <li>
          Customizable chart views allow users to focus on specific departments
          or teams for targeted insights.{" "}
        </li>
        <li>
          Real-time updates ensure the organizational charts reflect the most
          current structure and personnel changes.{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/visualization_viJFIn6Wt.gif?updatedAt=1720500231624",
  },
  {
    id: 4,
    title: "Synchronization",
    Heading:
      "Real-Time Data Synchronization of Microsoft 365 Employee directory",
    content: (
      <ul>
        <li>
          Real-time synchronization from Microsoft 365 ensures accurate and
          reliable employee data.
        </li>
        <li>
          Seamless integration keeps employee records up-to-date and provides an
          efficient system for managing organizational data.{" "}
        </li>
        <li>
          Instant updates to employee information are reflected across all
          integrated Microsoft 365 applications.{" "}
        </li>
        <li>
          Automated alerts notify users of important updates, ensuring quick
          action is taken when needed.{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/dataSync__gvNUPNCn.gif?updatedAt=1720500232251",
  },
  {
    id: 5,
    title: "Security",
    Heading: "Enhanced Confidentiality and Security: Employee Directory 365",
    content: (
      <ul>
        <li>
          Strong security features within the Microsoft 365 framework safeguard
          sensitive employee information.
        </li>
        <li>
          Prevents unauthorized access while ensuring compliance with
          organizational and industry standards.{" "}
        </li>
        <li>
          Granular access controls allow administrators to define permissions
          and restrict data visibility based on user roles.{" "}
        </li>
        <li>
          Regular security audits and compliance checks provide ongoing
          protection and peace of mind{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Security%20(1)_9wJphPYCa.gif?updatedAt=1720500232285",
  },
];

//ED2 sharepoint-employee-directory"

export const ED2FirstSection = {
  MainHeading:
    "Easy Access, Stronger Teams – Improve Communication with Employee Directory 365",
  MainDescription:
    "Our modern SharePoint employee directory is built-in with Microsoft 365 to help you gain easy access to team information and foster stronger communication across your organization.",
  MainImageAlt: "Employee Directory 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/ED365_sAcd5DKMg.png",
};

export const ED2Overview = {
  MainHeading:
    "Stay connected - connect with colleagues through SharePoint Employee Directory 365",
  MainDescription:
    "Employee Directory Software forms the foundation of a modern digital workplace by making it simple to locate colleagues based on their skills, expertise, or department. With clear profiles that highlight experience, interests, and activity, employees can connect and collaborate more effectively. The SharePoint Employee Directory application is easy to access directly from Microsoft Teams, Outlook, and SharePoint.",
  MainImageAlt: "Teams Helpdesk 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/Teams/MicrosoftTeams-image_En8P7Cj9x4.png",
};
export const ED2FAQs = [
  {
    title: `How to Buy Best Employee Directory?`,
    content: `Buy best employee directory by focusing on your needs—key features, integrations, and budget—and exploring well-reviewed options. Test free trials, compare value and support, and pick a trusted provider that aligns with your goals. Employee Directory 365 can be customised as per your business infrastructure and needs.`,
  },
  {
    title: `Does Microsoft have an employee directory?`,
    content: (
      <ul>
        Microsoft 365 includes tools for an employee directory:
        <li>Microsoft Teams: Search for colleagues by name or department. </li>
        <li>Outlook: Use the Global Address List for contact details. </li>
        <li>
          Delve: Explore detailed profiles, org charts, and shared documents.{" "}
        </li>
        <li>Easy-to-use interface. </li>
        <li>Advanced search options. </li>
        <li>Seamless integration with Microsoft 365. </li>
        This makes managing and finding employees simple and efficient.
      </ul>
    ),
  },
  {
    title: `How to find SharePoint directory?`,
    content: (
      <ul>
        To find a directory in SharePoint, such as an employee or document
        directory, follow these steps:
        <li>
          Go to Your SharePoint Site: Open the SharePoint site where the
          directory is stored.{" "}
        </li>
        <li>
          Search in Site Contents:
          <li>
            Click the Settings gear icon (top-right corner) and select Site
            Contents.
          </li>
          <li>
            Look for a list or library named after the directory (e.g.,
            "Employee Directory").{" "}
          </li>
        </li>
        <li>
          Use the Search Bar:
          <li>Use the Search bar at the top of the SharePoint page. </li>
          <li>
            Enter keywords like "directory" or "employee directory" to locate it
            quickly.{" "}
          </li>
        </li>
        <li>
          Check for Links or Pages: Some directories might be displayed on a
          custom page or as a link in the site’s navigation menu.{" "}
        </li>
        <li>
          Ask the Admin: If you can’t find the directory, your SharePoint
          administrator can provide access or guidance.{" "}
        </li>
        This should help you locate the directory you need!
      </ul>
    ),
  },

  {
    title: `What is Employee Directory system?`,
    content: (
      <ul>
        Employee Directory system is a central hub where you can find
        information about everyone in your organization.
        <li>
          Basic Information: Names, job titles, departments, and contact details
          (phone, email, etc.).{" "}
        </li>
        <li>
          Organizational Structure: Reporting hierarchy and team associations.{" "}
        </li>
        <li>
          Profiles: Additional details like photos, work locations, and
          expertise.{" "}
        </li>
      </ul>
    ),
  },
];

export const ed2tab = [
  {
    id: 1,
    title: "Collaboration",
    Heading: "Simplify Collaboration with Employee Directory Software",
    content: (
      <ul>
        <li>Boost teamwork and efficiency with Employee Directory software.</li>
        <li>
          Seamlessly integrated with Microsoft 365, turning your directory into
          a central hub within SharePoint and Teams.
        </li>
        <li>
          Quick access to important employee details, reducing
          platform-switching and improving focus.{" "}
        </li>
        <li>
          Automatic updates ensure your employee information is always accurate
          and current across all platforms.{" "}
        </li>
        <li>
          Customizable search and filter options make it simple to find and
          connect with colleagues.{" "}
        </li>
        Empower your team to work smarter and stay connected with ease.
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Integration_J10FfNdpZB.gif?updatedAt=1720500232501",
  },
  {
    id: 2,
    title: "Features",
    Heading: "Enhanced Search Features of Employee Directory app",
    content: (
      <ul>
        <li>
          Easily find colleagues by name, department, skills, or custom details
          using powerful search and filtering options.{" "}
        </li>
        <li>
          Save time in large organizations with advanced search functions that
          improve collaboration and efficiency.{" "}
        </li>
        <li>
          Quick access to frequently used filters with saved search preferences
          and recent queries.{" "}
        </li>
        <li>
          Visualize team dynamics with organizational chart integration, showing
          clear reporting structures for better understanding.{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Searching_bszxfaq2js.gif?updatedAt=1720500232508",
  },
  {
    id: 3,
    title: "Visualization",
    Heading:
      "Interactive Organizational Visualizations in Teams Employee directory",
    content: (
      <ul>
        <li>
          Dynamic organizational charts that visually display company hierarchy
          and reporting lines.{" "}
        </li>
        <li>
          Interactive charts help team members understand roles and assist
          managers in improving team structures for better collaboration and
          planning.{" "}
        </li>
        <li>
          Customizable chart views allow users to focus on specific departments
          or teams for targeted insights.{" "}
        </li>
        <li>
          Real-time updates ensure the organizational charts reflect the most
          current structure and personnel changes.{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/visualization_viJFIn6Wt.gif?updatedAt=1720500231624",
  },
  {
    id: 4,
    title: "Synchronization",
    Heading:
      "Real-Time Data Synchronization of Microsoft 365 Employee directory",
    content: (
      <ul>
        <li>
          Real-time synchronization from Microsoft 365 ensures accurate and
          reliable employee data.
        </li>
        <li>
          Seamless integration keeps employee records up-to-date and provides an
          efficient system for managing organizational data.{" "}
        </li>
        <li>
          Instant updates to employee information are reflected across all
          integrated Microsoft 365 applications.{" "}
        </li>
        <li>
          Automated alerts notify users of important updates, ensuring quick
          action is taken when needed.{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/dataSync__gvNUPNCn.gif?updatedAt=1720500232251",
  },
  {
    id: 5,
    title: "Security",
    Heading: "Enhanced Confidentiality and Security: Employee Directory 365",
    content: (
      <ul>
        <li>
          Strong security features within the Microsoft 365 framework safeguard
          sensitive employee information.
        </li>
        <li>
          Prevents unauthorized access while ensuring compliance with
          organizational and industry standards.{" "}
        </li>
        <li>
          Granular access controls allow administrators to define permissions
          and restrict data visibility based on user roles.{" "}
        </li>
        <li>
          Regular security audits and compliance checks provide ongoing
          protection and peace of mind{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Security%20(1)_9wJphPYCa.gif?updatedAt=1720500232285",
  },
];

// ED3 sharepoint-staff-directory

export const ED3FirstSection = {
  MainHeading:
    "Easy Access, Stronger Teams – Improve Communication with Employee Directory 365",
  MainDescription:
    "Our modern SharePoint staff directory is built-in with Microsoft 365 to help you gain easy access to team information and foster stronger communication across your organization.",
  MainImageAlt: "Employee Directory 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/ED365_sAcd5DKMg.png",
};

export const Ed3FAQs = [
  {
    title: `How to Create an employee directory SharePoint?`,
    content: (
      <ul>
        To create a SharePoint employee directory web part:
        <li>
          Open Your SharePoint Site: Open your SharePoint site where you want to
          create the directory.{" "}
        </li>
        <li>
          Create a List: Click + New List and name it "Employee Directory."{" "}
        </li>
        <li>
          Add Details: Add columns for Name, Job Title, Department, Phone,
          Email, etc.{" "}
        </li>
        <li>
          Fill the Directory: Enter employee details or import them from Excel.{" "}
        </li>
        <li>
          Display the Directory: Add the list to a page using the List Web Part
          and customize the view.{" "}
        </li>
        Your SharePoint employee directory is now live and ready to use!
      </ul>
    ),
  },
  {
    title: `Does Microsoft have an employee directory?`,
    content: (
      <ul>
        Microsoft 365 includes tools for an employee directory:
        <li>Microsoft Teams: Search for colleagues by name or department. </li>
        <li>Outlook: Use the Global Address List for contact details. </li>
        <li>
          Delve: Explore detailed profiles, org charts, and shared documents.{" "}
        </li>
        <li>Easy-to-use interface. </li>
        <li>Advanced search options. </li>
        <li>Seamless integration with Microsoft 365. </li>
        This makes managing and finding employees simple and efficient.
      </ul>
    ),
  },
  {
    title: `How to find SharePoint directory?`,
    content: (
      <ul>
        To find a directory in SharePoint, such as an employee or document
        directory, follow these steps:
        <li>
          Go to Your SharePoint Site: Open the SharePoint site where the
          directory is stored.{" "}
        </li>
        <li>
          Search in Site Contents:
          <li>
            Click the Settings gear icon (top-right corner) and select Site
            Contents.
          </li>
          <li>
            Look for a list or library named after the directory (e.g.,
            "Employee Directory").{" "}
          </li>
        </li>
        <li>
          Use the Search Bar:
          <li>Use the Search bar at the top of the SharePoint page. </li>
          <li>
            Enter keywords like "directory" or "employee directory" to locate it
            quickly.{" "}
          </li>
        </li>
        <li>
          Check for Links or Pages: Some directories might be displayed on a
          custom page or as a link in the site’s navigation menu.{" "}
        </li>
        <li>
          Ask the Admin: If you can’t find the directory, your SharePoint
          administrator can provide access or guidance.{" "}
        </li>
        This should help you locate the directory you need!
      </ul>
    ),
  },

  {
    title: `What is employee directory?`,
    content: (
      <ul>
        A SharePoint employee directory 365 is a central hub where you can find
        information about everyone in your organization.
        <li>
          Basic Information: Names, job titles, departments, and contact details
          (phone, email, etc.).{" "}
        </li>
        <li>
          Organizational Structure: Reporting hierarchy and team associations.
        </li>
        <li>
          Profiles: Additional details like photos, work locations, and
          expertise.{" "}
        </li>
      </ul>
    ),
  },
];

export const ed3tab = [
  {
    id: 1,
    title: "Collaboration",
    Heading: "Simplify Collaboration with SharePoint Employee Directory",
    content: (
      <ul>
        <li>
          Boost teamwork and efficiency with SharePoint employee directory
          online– Employee Directory 365.{" "}
        </li>
        <li>
          Seamlessly integrated with Microsoft 365, turning your directory into
          a central hub within SharePoint and Teams.{" "}
        </li>
        <li>
          Quick access to important employee details, reducing
          platform-switching and improving focus.{" "}
        </li>
        <li>
          Automatic updates ensure your employee information is always accurate
          and current across all platforms.{" "}
        </li>
        <li>
          Customizable search and filter options make it simple to find and
          connect with colleagues.{" "}
        </li>
        Empower your team to work smarter and stay connected with ease.
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Integration_J10FfNdpZB.gif?updatedAt=1720500232501",
  },
  {
    id: 2,
    title: "Features",
    Heading: "Enhanced Search Features: SharePoint Employee Directory App",
    content: (
      <ul>
        <li>
          Easily find colleagues by name, department, skills, or custom details
          using powerful search and filtering options.{" "}
        </li>
        <li>
          Save time in large organizations with advanced search functions that
          improve collaboration and efficiency.{" "}
        </li>
        <li>
          Quick access to frequently used filters with saved search preferences
          and recent queries.{" "}
        </li>
        <li>
          Visualize team dynamics with organizational chart integration, showing
          clear reporting structures for better understanding.{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Searching_bszxfaq2js.gif?updatedAt=1720500232508",
  },
  {
    id: 3,
    title: "Visualization",
    Heading:
      "Interactive Organizational Visualizations – Modern SharePoint Employee Directory Online",
    content: (
      <ul>
        <li>
          Dynamic organizational charts that visually display company hierarchy
          and reporting lines.{" "}
        </li>
        <li>
          Interactive charts help team members understand roles and assist
          managers in improving team structures for better collaboration and
          planning.{" "}
        </li>
        <li>
          Customizable chart views allow users to focus on specific departments
          or teams for targeted insights.{" "}
        </li>
        <li>
          Real-time updates ensure the organizational charts reflect the most
          current structure and personnel changes.{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/visualization_viJFIn6Wt.gif?updatedAt=1720500231624",
  },
  {
    id: 4,
    title: "Synchronization",
    Heading:
      "Real-Time Data Synchronization: SharePoint Employee Directory Webpart",
    content: (
      <ul>
        <li>
          Real-time synchronization from Microsoft 365 ensures accurate and
          reliable employee data.{" "}
        </li>
        <li>
          Seamless integration keeps employee records up-to-date and provides an
          efficient system for managing organizational data.{" "}
        </li>
        <li>
          Instant updates to employee information are reflected across all
          integrated Microsoft 365 applications.{" "}
        </li>
        <li>
          Automated alerts notify users of important updates, ensuring quick
          action is taken when needed.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/dataSync__gvNUPNCn.gif?updatedAt=1720500232251",
  },
  {
    id: 5,
    title: "Security",
    Heading: "Enhanced Confidentiality and Security: Employee Directory 365",
    content: (
      <ul>
        <li>
          Strong security features within the Microsoft 365 framework safeguard
          sensitive employee information.{" "}
        </li>
        <li>
          Prevents unauthorized access while ensuring compliance with
          organizational and industry standards.{" "}
        </li>
        <li>
          Granular access controls allow administrators to define permissions
          and restrict data visibility based on user roles.{" "}
        </li>
        <li>
          Regular security audits and compliance checks provide ongoing
          protection and peace of mind.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Security%20(1)_9wJphPYCa.gif?updatedAt=1720500232285",
  },
];

// Page ED4 /microsoft-employee-directory-365

export const ED4FirstSection = {
  MainHeading:
    "Easy Access, Stronger Teams – Improve Communication with Employee Directory 365",
  MainDescription:
    "Our modern Microsoft Employee directory is built-in with Microsoft 365 to help you gain easy access to team information and foster stronger communication across your organization.",
  MainImageAlt: "Employee Directory 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/ED365_sAcd5DKMg.png",
};

export const Ed4FAQs = [
  {
    title: `How to Create a SharePoint staff directory?`,
    content: (
      <ul>
        To create a SharePoint people directory:
        <li>
          Open Your SharePoint Site: Open your SharePoint site where you want to
          create the directory.{" "}
        </li>
        <li>
          Create a List: Click + New List and name it "Employee Directory."{" "}
        </li>
        <li>
          Add Details: Add columns for Name, Job Title, Department, Phone,
          Email, etc.
        </li>
        <li>
          Fill the Directory: Enter employee details or import them from Excel.{" "}
        </li>
        <li>
          Display the Directory: Add the list to a page using the List Web Part
          and customize the view.{" "}
        </li>
        Your SharePoint employee directory is now live and ready to use!
      </ul>
    ),
  },
  {
    title: `Does Microsoft have an employee directory?`,
    content: (
      <ul>
        Microsoft 365 includes tools for an employee directory:
        <li>Microsoft Teams: Search for colleagues by name or department. </li>
        <li>Outlook: Use the Global Address List for contact details. </li>
        <li>
          Delve: Explore detailed profiles, org charts, and shared documents.{" "}
        </li>
        <li>Easy-to-use interface. </li>
        <li>Advanced search options. </li>
        <li>Seamless integration with Microsoft 365. </li>
        This makes managing and finding employees simple and efficient.
      </ul>
    ),
  },
  {
    title: `How to find SharePoint directory?`,
    content: (
      <ul>
        To find a directory in SharePoint, such as an employee or document
        directory, follow these steps:
        <li>
          Go to Your SharePoint Site: Open the SharePoint site where the
          directory is stored.{" "}
        </li>
        <li>
          Search in Site Contents:
          <li>
            Click the Settings gear icon (top-right corner) and select Site
            Contents.{" "}
          </li>
          <li>
            Look for a list or library named after the directory (e.g.,
            "Employee Directory").{" "}
          </li>
        </li>
        <li>
          Check for Links or Pages: Some directories might be displayed on a
          custom page or as a link in the site’s navigation menu.{" "}
        </li>
        <li>
          Ask the Admin: If you can’t find the directory, your SharePoint
          administrator can provide access or guidance.{" "}
        </li>
        This should help you locate the directory you need!
      </ul>
    ),
  },

  {
    title: `What is SharePoint company directory`,
    content: (
      <ul>
        A SharePoint people directory is a central hub where you can find
        information about everyone in your organization.
        <li>
          Basic Information: Names, job titles, departments, and contact details
          (phone, email, etc.).
        </li>
        <li>
          Organizational Structure: Reporting hierarchy and team associations.
        </li>
        <li>
          Profiles: Additional details like photos, work locations, and
          expertise.
        </li>
      </ul>
    ),
  },
];

export const ed4tab = [
  {
    id: 1,
    title: "Collaboration",
    Heading: "Simplify Collaboration with SharePoint staff directory",
    content: (
      <ul>
        <li>
          Boost teamwork and efficiency with SharePoint online staff directory –
          Employee Directory 365.{" "}
        </li>
        <li>
          Seamlessly integrated with Microsoft 365, turning your directory into
          a central hub within SharePoint and Teams.{" "}
        </li>
        <li>
          Quick access to important employee details, reducing
          platform-switching and improving focus.{" "}
        </li>
        <li>
          Automatic updates ensure your employee information is always accurate
          and current across all platforms.
        </li>
        <li>
          Customizable search and filter options make it simple to find and
          connect with colleagues.{" "}
        </li>
        Empower your team to work smarter and stay connected with ease.
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Integration_J10FfNdpZB.gif?updatedAt=1720500232501",
  },
  {
    id: 2,
    title: "Features",
    Heading: "Enhanced Search Features of SharePoint Company Directory",
    content: (
      <ul>
        <li>
          Easily find colleagues by name, department, skills, or custom details
          using powerful search and filtering options.{" "}
        </li>
        <li>
          Save time in large organizations with advanced search functions that
          improve collaboration and efficiency.{" "}
        </li>
        <li>
          Quick access to frequently used filters with saved search preferences
          and recent queries.
        </li>
        <li>
          Visualize team dynamics with organizational chart integration, showing
          clear reporting structures for better understanding.{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Searching_bszxfaq2js.gif?updatedAt=1720500232508",
  },
  {
    id: 3,
    title: "Visualization",
    Heading:
      "Interactive Organizational Visualizations in SharePoint People Directory ",
    content: (
      <ul>
        <li>
          Dynamic organizational charts that visually display company hierarchy
          and reporting lines.{" "}
        </li>
        <li>
          Interactive charts help team members understand roles and assist
          managers in improving team structures for better collaboration and
          planning.{" "}
        </li>
        <li>
          Customizable chart views allow users to focus on specific departments
          or teams for targeted insights.{" "}
        </li>
        <li>
          Real-time updates ensure the organizational charts reflect the most
          current structure and personnel changes.{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/visualization_viJFIn6Wt.gif?updatedAt=1720500231624",
  },
  {
    id: 4,
    title: "Data Synchronization",
    Heading:
      "Real-Time Data Synchronization of SharePoint online people directory",
    content: (
      <ul>
        <li>
          Real-time synchronization from Microsoft 365 ensures accurate and
          reliable employee data.{" "}
        </li>
        <li>
          Seamless integration keeps employee records up-to-date and provides an
          efficient system for managing organizational data.{" "}
        </li>
        <li>
          Instant updates to employee information are reflected across all
          integrated Microsoft 365 applications.{" "}
        </li>
        <li>
          Automated alerts notify users of important updates, ensuring quick
          action is taken when needed.{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/dataSync__gvNUPNCn.gif?updatedAt=1720500232251",
  },
  {
    id: 5,
    title: "Security",
    Heading: "Enhanced Confidentiality and Security: Employee Directory 365  ",
    content: (
      <ul>
        <li>
          Strong security features within the Microsoft 365 framework safeguard
          sensitive employee information.
        </li>
        <li>
          Prevents unauthorized access while ensuring compliance with
          organizational and industry standards.{" "}
        </li>
        <li>
          Granular access controls allow administrators to define permissions
          and restrict data visibility based on user roles.
        </li>
        <li>
          Regular security audits and compliance checks provide ongoing
          protection and peace of mind{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Security%20(1)_9wJphPYCa.gif?updatedAt=1720500232285",
  },
];

// Page ED4 hr-directory-365

export const ED5FirstSection = {
  MainHeading:
    "Easy Access, Stronger Teams – Improve Communication with Employee Directory 365",
  MainDescription:
    "Our modern HR Directory is built-in with Microsoft 365 to help you gain easy access to team information and foster stronger communication across your organization.",
  MainImageAlt: "Employee Directory 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/productPAGES/ED365_sAcd5DKMg.png",
};

export const Ed5FAQs = [
  {
    title: `How to Create a Microsoft 365 Employee directory?`,
    content: (
      <ul>
        To create an Employee directory in Microsoft Teams:
        <li>
          Open Your SharePoint Site: Open your SharePoint site where you want to
          create the directory.{" "}
        </li>
        <li>
          Create a List: Click + New List and name it "Employee Directory."{" "}
        </li>
        <li>
          Add Details: Add columns for Name, Job Title, Department, Phone,
          Email, etc.{" "}
        </li>
        <li>
          Fill the Directory: Enter employee details or import them from Excel.{" "}
        </li>
        <li>
          Display the Directory: Add the list to a page using the List Web Part
          and customize the view.{" "}
        </li>
        Your SharePoint employee directory is now live and ready to use!
      </ul>
    ),
  },
  {
    title: `Does Microsoft have an Employee Directory?`,
    content: (
      <ul>
        Microsoft 365 includes tools for an employee directory:
        <li>Microsoft Teams: Search for colleagues by name or department.</li>
        <li>Outlook: Use the Global Address List for contact details. </li>
        <li>
          Delve: Explore detailed profiles, org charts, and shared documents.{" "}
        </li>
        <li>Easy-to-use interface.</li>
        <li>Advanced search options. </li>
        <li>Seamless integration with Microsoft 365. </li>
        This makes managing and finding employees simple and efficient.
      </ul>
    ),
  },
  {
    title: `How to find SharePoint Directory?`,
    content: (
      <ul>
        To find a directory in SharePoint, such as an employee or document
        directory, follow these steps:
        <li>
          Go to Your SharePoint Site: Open the SharePoint site where the
          directory is stored.{" "}
        </li>
        <li>
          Search in Site Contents:
          <li>
            Click the Settings gear icon (top-right corner) and select Site
            Contents.{" "}
          </li>
          <li>
            Look for a list or library named after the directory (e.g.,
            "Employee Directory").{" "}
          </li>
        </li>
        <li>
          Use the Search Bar:
          <li>Use the Search bar at the top of the SharePoint page. </li>
          <li>
            Enter keywords like "directory" or "employee directory" to locate it
            quickly.{" "}
          </li>
        </li>
        <li>
          Check for Links or Pages: Some directories might be displayed on a
          custom page or as a link in the site’s navigation menu.{" "}
        </li>
        <li>
          Ask the Admin: If you can’t find the directory, your SharePoint
          administrator can provide access or guidance.{" "}
        </li>
        This should help you locate the directory you need!
      </ul>
    ),
  },

  {
    title: `What is Microsoft Employee directory? `,
    content: (
      <ul>
        A Microsoft Employee directory is a central hub where you can find
        information about everyone in your organization.
        <li>
          Basic Information: Names, job titles, departments, and contact details
          (phone, email, etc.).{" "}
        </li>
        <li>
          Organizational Structure: Reporting hierarchy and team associations.{" "}
        </li>
        <li>
          Profiles: Additional details like photos, work locations, and
          expertise.{" "}
        </li>
      </ul>
    ),
  },
];

export const ed5tab = [
  {
    id: 1,
    title: "Collaboration",
    Heading: "Simplify Collaboration with Microsoft 365 Employee directory",
    content: (
      <ul>
        <li>Boost teamwork and efficiency with Teams Employee Directory. </li>
        <li>
          Seamlessly integrated with Microsoft 365, turning your directory into
          a central hub within SharePoint and Teams.{" "}
        </li>
        <li>
          Quick access to important employee details, reducing
          platform-switching and improving focus.
        </li>
        <li>
          Automatic updates ensure your employee information is always accurate
          and current across all platforms.
        </li>
        <li>
          Customizable search and filter options make it simple to find and
          connect with colleagues.{" "}
        </li>
        Empower your team to work smarter and stay connected with ease.
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Integration_J10FfNdpZB.gif?updatedAt=1720500232501",
  },
  {
    id: 2,
    title: "Features",
    Heading: "Enhanced Search Features of Microsoft Teams Employee directory ",
    content: (
      <ul>
        <li>
          Easily find colleagues by name, department, skills, or custom details
          using powerful search and filtering options.{" "}
        </li>
        <li>
          Save time in large organizations with advanced search functions that
          improve collaboration and efficiency.{" "}
        </li>
        <li>
          Quick access to frequently used filters with saved search preferences
          and recent queries.{" "}
        </li>
        <li>
          Visualize team dynamics with organizational chart integration, showing
          clear reporting structures for better understanding.{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Searching_bszxfaq2js.gif?updatedAt=1720500232508",
  },
  {
    id: 3,
    title: "Visualization",
    Heading:
      "Interactive Organizational Visualizations in Teams Employee directory",
    content: (
      <ul>
        <li>
          Dynamic organizational charts that visually display company hierarchy
          and reporting lines.{" "}
        </li>
        <li>
          Interactive charts help team members understand roles and assist
          managers in improving team structures for better collaboration and
          planning.{" "}
        </li>
        <li>
          Customizable chart views allow users to focus on specific departments
          or teams for targeted insights.{" "}
        </li>
        <li>
          Real-time updates ensure the organizational charts reflect the most
          current structure and personnel changes.{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/visualization_viJFIn6Wt.gif?updatedAt=1720500231624",
  },
  {
    id: 4,
    title: "Data Synchronization",
    Heading:
      "Real-Time Data Synchronization of Microsoft 365 Employee directory",
    content: (
      <ul>
        <li>
          Real-time synchronization from Microsoft 365 ensures accurate and
          reliable employee data.{" "}
        </li>
        <li>
          Seamless integration keeps employee records up-to-date and provides an
          efficient system for managing organizational data.{" "}
        </li>
        <li>
          Instant updates to employee information are reflected across all
          integrated Microsoft 365 applications.{" "}
        </li>
        <li>
          Automated alerts notify users of important updates, ensuring quick
          action is taken when needed.{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/dataSync__gvNUPNCn.gif?updatedAt=1720500232251",
  },
  {
    id: 5,
    title: "Security",
    Heading: " Enhanced Confidentiality and Security: Employee Directory 365",
    content: (
      <ul>
        <li>
          Strong security features within the Microsoft 365 framework safeguard
          sensitive employee information.{" "}
        </li>
        <li>
          Prevents unauthorized access while ensuring compliance with
          organizational and industry standards.{" "}
        </li>
        <li>
          Granular access controls allow administrators to define permissions
          and restrict data visibility based on user roles.{" "}
        </li>
        <li>
          Regular security audits and compliance checks provide ongoing
          protection and peace of mind{" "}
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/ED365/Security%20(1)_9wJphPYCa.gif?updatedAt=1720500232285",
  },
];

// Timesheet LP Pages

//TS1 "/time-tracking-1",

export const TS1FirstSection = {
  MainHeading:
    "Turn Time into Productivity: Experience Seamless Tracking with Timesheet 365",
  MainDescription:
    "Effortlessly manage projects, tasks, and time with our powerful, user-friendly solution designed for Microsoft 365. Timesheet 365 brings simplicity and precision to your team’s time tracking, empowering you to focus on what truly matters – achieving your goals. Start your journey toward smarter work today!",
  MainImageAlt: "Employee Directory 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Lp-page-Logos/Untitled%20design%20(56)_kTV58u1og.webp",
};

export const TS1Overview = {
  MainHeading:
    "Experience the Perfect Balance of Automation and Human Insights with Timesheet 365",
  MainDescription:
    "Time tracking shouldn’t slow you down—let automation do the work. Timesheet 365 makes it easy to log hours, manage approvals, and create reports, seamlessly integrating with Microsoft 365 apps like Teams, Outlook, and SharePoint.",
  MainImageAlt: "Teams Timesheet 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/Teams/image%20(13)_DuxVqwrgl.png",
};

export const TS1FAQs = [
  {
    title: `1. Does the Microsoft Time tracking app integrate with other Microsoft 365 tools?`,
    content: `Yes, the Microsoft Time tracking app seamlessly integrates with other Microsoft 365 tools like Teams, Outlook, and SharePoint, enabling efficient collaboration and data sharing across the organization.`,
  },
  {
    title: `2. Can I customize the SharePoint Timesheet app to fit my organization’s needs?`,
    content: `Yes, the SharePoint Timesheet app is highly customizable. You can tailor fields, forms, workflows, and approval processes to match your organization’s specific time-tracking requirements.`,
  },
  {
    title: `3. Can I install multiple instances of Timesheet 365? Can I install multiple instances of Timesheet 365?`,
    content: `Yes, you can install multiple instances of the application as long as it is in one Microsoft 365 tenant and total number of users of all the instances installed remain within the user limit as per your plan or license you purchased.`,
  },
  {
    title: `4. How to add task details in weekly bases?`,
    content: `Go to Home page.

Select Timesheet tab. Under that select Weekly Timesheet.

Select the week for which you want to add your projects & task details and click on Add button.

Select the Project, Task and Activity Type from the dropdown list and fill the time spent on a particular task for a selected week, which will automatically calculate

the Total hours spent.`,
  },
  {
    title: `5. Can we clone a weekly timesheet while adding a new weekly timesheet?`,
    content: `Yes, you can clone previous week’s timesheet to the new timesheet if you have worked on the same project & task.

Go to Home page.

Select Timesheets tab.

Choose Clone Weekly Timesheet tab and then click on Clone button.

Project will be added to your Weekly timesheet.

You can mention the time spent for a particular task on each day of the week and click on Submit button.`,
  },
  {
    title: `6. How to add a task?`,
    content: `Go to Home page.

Select the Task tab.

Once the pop-up opens, choose the Project, and enter the Task Name for the respective project.

Then click on submit button. This task would be added into the task list which will fetch while entering your daily timesheet.`,
  },
  {
    title: `7. How to assign a task to an employee?`,
    content: `Select the Assign Task tab.Once the pop-up opens, select the project name and task name and choose a person to whom you want to assign to and click on Submit.ss`,
  },
  {
    title: `8. How to change the theme color in Timesheet Plus - application?`,
    content: `After logging into application, please click on Settings tab on the side-navigation.

In Settings, choose the Pre-defined Themes or you can define your Custom-Themes.`,
  },
  {
    title: `9. How to add new client?`,
    content: `Go to Administrator tab, select Clients.

Once pop-up opens, click on Add button.

You can fill all the client details, and their contact details. If they have documents, you can also attach it.

Once done, you can click on submit button.`,
  },
  {
    title: `10. What is the role of Project Observer?`,
    content: `A Project Observer can view all aspects of a Project. Observers cannot make any changes to the project. Project Observer is a read-only role.`,
  },
];

export const TS1tab1 = [
  {
    id: 1,
    title: "Microsoft Time Tracking",
    Heading: "Microsoft Time Tracking Software for all businesses",
    content: (
      <ul>
        <li>
          Transform project management with Timesheet 365, a cloud-based
          timesheet software for businesses of all sizes.
        </li>
        <li>
          This time tracking app offers detailed insights into time allocation
          and activities, enhancing billing accuracy and operational efficiency.
        </li>
        <li>
          Its intuitive interface ensures precise tracking and a comprehensive
          view of past activities for data-driven decision-making and optimized
          workflows.
        </li>
        <li>
          Seamless integration with other Microsoft 365 tools enhances workflow
          efficiency and provides a unified view of project and time data.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/TimeTrack_mOyvlDqZgm.gif?updatedAt=1720167132158",
  },
  {
    id: 2,
    title: "Seamless Collaboration",
    Heading: " Seamless Collaboration with Employee Time Tracking Software",
    content: (
      <ul>
        <li>
          Efficiently manage timesheets with our time tracking app, designed for
          easy reporting for users and managers.
        </li>
        <li>
          Microsoft time tracking software offers smooth time logging, powerful
          reporting tools, and flexible filtering options.
        </li>
        <li>
          From high-level overviews to detailed breakdowns, it supports seamless
          collaboration and informed decision-making.
        </li>
        <li>
          Automated time capture and reminders reduce manual entries and ensure
          accurate logging of work hours.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/SeamlessCollab_iYj0QjoIJ6.gif?updatedAt=1720167132341",
  },
  {
    id: 3,
    title: "Review Workflow ",
    Heading: "Review Workflow in the SharePoint Time tracking  ",
    content: (
      <ul>
        <li>
          SharePoint timesheet app streamlines the approval process for enhanced
          workflow efficiency.
        </li>
        <li>
          Upon task completion or weekly submission, it automatically triggers
          an approval workflow.
        </li>
        <li>
          Managers can review entries for accuracy and compliance, with users
          locked out from editing approved entries.
        </li>
        <li>
          SharePoint Timesheet also offers responsive mobile layouts for
          managers to review and approve timesheets from any device.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/ReviewWorkflow_oH_zTtrwNo.gif?updatedAt=1720167132438",
  },
  {
    id: 4,
    title: "Unlimited Projects ",
    Heading: "Unlimited Projects & Clients in Our SharePoint Timesheet  ",
    content: (
      <ul>
        <li>
          SharePoint Timesheet app streamlines project management by enabling
          easy creation and oversight of customer accounts, tracking billable
          and non-billable hours, and setting custom rates for invoicing.
        </li>
        <li>
          It integrates a centralized repository within employee timesheet
          software for easy document management.
        </li>
        <li>
          Key features include unlimited projects and clients, built-in
          stopwatch/timer, real-time report generation, and automatic timesheet
          approval.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/Unlimitedprojectandclient_M-TLMLTJ5Q.gif?updatedAt=1720167132311",
  },
  {
    id: 5,
    title: "Reports",
    Heading: "Generate Reports with Microsoft 365 time tracking app  ",
    content: (
      <ul>
        <li>
          SharePoint Timesheet app provides comprehensive insights into project
          timelines and activities.
        </li>
        <li>
          Track individual time entries and generate real-time reports
          exportable to Excel.
        </li>
        <li>
          This Microsoft time tracking software offers detailed monthly, weekly,
          and project-based reports, highlighting billable vs. non-billable
          hours and team performance for informed decision-making and
          streamlined project management.
        </li>
        <li>
          Customizable report templates allow you to tailor data presentations
          to specific project needs or stakeholder requirements.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/Reports_EZrX33OX9.gif?updatedAt=1720167132311",
  },
];

// TS "/time-tracking-2",
export const TS2FirstSection = {
  MainHeading:
    "Turn Time into Productivity: Experience Seamless Tracking with Timesheet 365",
  MainDescription:
    "Effortlessly manage projects, tasks, and time with our powerful, user-friendly solution designed for Microsoft 365. Timesheet 365 brings simplicity and precision to your team’s time tracking, empowering you to focus on what truly matters – achieving your goals. Start your journey toward smarter work today!",
  MainImageAlt: "Employee Directory 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Lp-page-Logos/Untitled%20design%20(56)_kTV58u1og.webp",
};

export const TS2tab1 = [
  {
    id: 1,
    title: "Microsoft Time Tracking",
    Heading: "Microsoft Time Tracking Software for all businesses",
    content: (
      <ul>
        <li>
          Transform project management with Timesheet 365, a cloud-based
          timesheet software for businesses of all sizes.
        </li>
        <li>
          This time tracking app offers detailed insights into time allocation
          and activities, enhancing billing accuracy and operational efficiency.
        </li>
        <li>
          Its intuitive interface ensures precise tracking and a comprehensive
          view of past activities for data-driven decision-making and optimized
          workflows.
        </li>
        <li>
          Seamless integration with other Microsoft 365 tools enhances workflow
          efficiency and provides a unified view of project and time data.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/TimeTrack_mOyvlDqZgm.gif?updatedAt=1720167132158",
  },
  {
    id: 2,
    title: "Seamless Collaboration",
    Heading: " Seamless Collaboration with Employee Time Tracking Software",
    content: (
      <ul>
        <li>
          Efficiently manage timesheets with our time tracking app, designed for
          easy reporting for users and managers.
        </li>
        <li>
          Microsoft time tracking software offers smooth time logging, powerful
          reporting tools, and flexible filtering options.
        </li>
        <li>
          From high-level overviews to detailed breakdowns, it supports seamless
          collaboration and informed decision-making.
        </li>
        <li>
          Automated time capture and reminders reduce manual entries and ensure
          accurate logging of work hours.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/SeamlessCollab_iYj0QjoIJ6.gif?updatedAt=1720167132341",
  },
  {
    id: 3,
    title: "Review Workflow ",
    Heading: "Review Workflow in the SharePoint Time tracking  ",
    content: (
      <ul>
        <li>
          SharePoint timesheet app streamlines the approval process for enhanced
          workflow efficiency.
        </li>
        <li>
          Upon task completion or weekly submission, it automatically triggers
          an approval workflow.
        </li>
        <li>
          Managers can review entries for accuracy and compliance, with users
          locked out from editing approved entries.
        </li>
        <li>
          SharePoint Timesheet also offers responsive mobile layouts for
          managers to review and approve timesheets from any device.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/ReviewWorkflow_oH_zTtrwNo.gif?updatedAt=1720167132438",
  },
  {
    id: 4,
    title: "Unlimited Projects ",
    Heading: "Unlimited Projects & Clients in Our SharePoint Timesheet  ",
    content: (
      <ul>
        <li>
          SharePoint Timesheet app streamlines project management by enabling
          easy creation and oversight of customer accounts, tracking billable
          and non-billable hours, and setting custom rates for invoicing.
        </li>
        <li>
          It integrates a centralized repository within employee timesheet
          software for easy document management.
        </li>
        <li>
          Key features include unlimited projects and clients, built-in
          stopwatch/timer, real-time report generation, and automatic timesheet
          approval.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/Unlimitedprojectandclient_M-TLMLTJ5Q.gif?updatedAt=1720167132311",
  },
  {
    id: 5,
    title: "Reports",
    Heading: "Generate Reports with Microsoft 365 time tracking app  ",
    content: (
      <ul>
        <li>
          SharePoint Timesheet app provides comprehensive insights into project
          timelines and activities.
        </li>
        <li>
          Track individual time entries and generate real-time reports
          exportable to Excel.
        </li>
        <li>
          This Microsoft time tracking software offers detailed monthly, weekly,
          and project-based reports, highlighting billable vs. non-billable
          hours and team performance for informed decision-making and
          streamlined project management.
        </li>
        <li>
          Customizable report templates allow you to tailor data presentations
          to specific project needs or stakeholder requirements.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/Reports_EZrX33OX9.gif?updatedAt=1720167132311",
  },
];

export const TS2FAQs = [
  {
    title: `1. Does the Microsoft Time tracking app integrate with other Microsoft 365 tools?`,
    content: `Yes, the Microsoft Time tracking app seamlessly integrates with other Microsoft 365 tools like Teams, Outlook, and SharePoint, enabling efficient collaboration and data sharing across the organization.`,
  },
  {
    title: `2. Can I customize the SharePoint Timesheet app to fit my organization’s needs?`,
    content: `Yes, the SharePoint Timesheet app is highly customizable. You can tailor fields, forms, workflows, and approval processes to match your organization’s specific time-tracking requirements.`,
  },
  {
    title: `3. Can I install multiple instances of Timesheet 365? Can I install multiple instances of Timesheet 365?`,
    content: `Yes, you can install multiple instances of the application as long as it is in one Microsoft 365 tenant and total number of users of all the instances installed remain within the user limit as per your plan or license you purchased.`,
  },
  {
    title: `4. How to add task details in weekly bases?`,
    content: `Go to Home page.

Select Timesheet tab. Under that select Weekly Timesheet.

Select the week for which you want to add your projects & task details and click on Add button.

Select the Project, Task and Activity Type from the dropdown list and fill the time spent on a particular task for a selected week, which will automatically calculate

the Total hours spent.`,
  },
  {
    title: `5. Can we clone a weekly timesheet while adding a new weekly timesheet?`,
    content: `Yes, you can clone previous week’s timesheet to the new timesheet if you have worked on the same project & task.

Go to Home page.

Select Timesheets tab.

Choose Clone Weekly Timesheet tab and then click on Clone button.

Project will be added to your Weekly timesheet.

You can mention the time spent for a particular task on each day of the week and click on Submit button.`,
  },
  {
    title: `6. How to add a task?`,
    content: `Go to Home page.

Select the Task tab.

Once the pop-up opens, choose the Project, and enter the Task Name for the respective project.

Then click on submit button. This task would be added into the task list which will fetch while entering your daily timesheet.`,
  },
  {
    title: `7. How to assign a task to an employee?`,
    content: `Select the Assign Task tab.Once the pop-up opens, select the project name and task name and choose a person to whom you want to assign to and click on Submit.ss`,
  },
  {
    title: `8. How to change the theme color in Timesheet Plus - application?`,
    content: `After logging into application, please click on Settings tab on the side-navigation.

In Settings, choose the Pre-defined Themes or you can define your Custom-Themes.`,
  },
  {
    title: `9. How to add new client?`,
    content: `Go to Administrator tab, select Clients.

Once pop-up opens, click on Add button.

You can fill all the client details, and their contact details. If they have documents, you can also attach it.

Once done, you can click on submit button.`,
  },
  {
    title: `10. What is the role of Project Observer?`,
    content: `A Project Observer can view all aspects of a Project. Observers cannot make any changes to the project. Project Observer is a read-only role.`,
  },
];

// TS /time-tracking-3

export const TS3FirstSection = {
  MainHeading:
    "Turn Time into Productivity: Experience Seamless Tracking with Timesheet 365",
  MainDescription:
    "Effortlessly manage projects, tasks, and time with our powerful, user-friendly solution designed for Microsoft 365. Timesheet 365 brings simplicity and precision to your team’s time tracking, empowering you to focus on what truly matters – achieving your goals. Start your journey toward smarter work today!",
  MainImageAlt: "Employee Directory 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Lp-page-Logos/Untitled%20design%20(56)_kTV58u1og.webp",
};

export const TS3tab1 = [
  {
    id: 1,
    title: "Microsoft Time Tracking",
    Heading: "Microsoft Time Tracking Software for all businesses",
    content: (
      <ul>
        <li>
          Transform project management with Timesheet 365, a cloud-based
          timesheet software for businesses of all sizes.
        </li>
        <li>
          This time tracking app offers detailed insights into time allocation
          and activities, enhancing billing accuracy and operational efficiency.
        </li>
        <li>
          Its intuitive interface ensures precise tracking and a comprehensive
          view of past activities for data-driven decision-making and optimized
          workflows.
        </li>
        <li>
          Seamless integration with other Microsoft 365 tools enhances workflow
          efficiency and provides a unified view of project and time data.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/TimeTrack_mOyvlDqZgm.gif?updatedAt=1720167132158",
  },
  {
    id: 2,
    title: "Seamless Collaboration",
    Heading: " Seamless Collaboration with Employee Time Tracking Software",
    content: (
      <ul>
        <li>
          Efficiently manage timesheets with our time tracking app, designed for
          easy reporting for users and managers.
        </li>
        <li>
          Microsoft time tracking software offers smooth time logging, powerful
          reporting tools, and flexible filtering options.
        </li>
        <li>
          From high-level overviews to detailed breakdowns, it supports seamless
          collaboration and informed decision-making.
        </li>
        <li>
          Automated time capture and reminders reduce manual entries and ensure
          accurate logging of work hours.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/SeamlessCollab_iYj0QjoIJ6.gif?updatedAt=1720167132341",
  },
  {
    id: 3,
    title: "Review Workflow ",
    Heading: "Review Workflow in the SharePoint Time tracking  ",
    content: (
      <ul>
        <li>
          SharePoint timesheet app streamlines the approval process for enhanced
          workflow efficiency.
        </li>
        <li>
          Upon task completion or weekly submission, it automatically triggers
          an approval workflow.
        </li>
        <li>
          Managers can review entries for accuracy and compliance, with users
          locked out from editing approved entries.
        </li>
        <li>
          SharePoint Timesheet also offers responsive mobile layouts for
          managers to review and approve timesheets from any device.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/ReviewWorkflow_oH_zTtrwNo.gif?updatedAt=1720167132438",
  },
  {
    id: 4,
    title: "Unlimited Projects ",
    Heading: "Unlimited Projects & Clients in Our SharePoint Timesheet  ",
    content: (
      <ul>
        <li>
          SharePoint Timesheet app streamlines project management by enabling
          easy creation and oversight of customer accounts, tracking billable
          and non-billable hours, and setting custom rates for invoicing.
        </li>
        <li>
          It integrates a centralized repository within employee timesheet
          software for easy document management.
        </li>
        <li>
          Key features include unlimited projects and clients, built-in
          stopwatch/timer, real-time report generation, and automatic timesheet
          approval.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/Unlimitedprojectandclient_M-TLMLTJ5Q.gif?updatedAt=1720167132311",
  },
  {
    id: 5,
    title: "Reports",
    Heading: "Generate Reports with Microsoft 365 time tracking app  ",
    content: (
      <ul>
        <li>
          SharePoint Timesheet app provides comprehensive insights into project
          timelines and activities.
        </li>
        <li>
          Track individual time entries and generate real-time reports
          exportable to Excel.
        </li>
        <li>
          This Microsoft time tracking software offers detailed monthly, weekly,
          and project-based reports, highlighting billable vs. non-billable
          hours and team performance for informed decision-making and
          streamlined project management.
        </li>
        <li>
          Customizable report templates allow you to tailor data presentations
          to specific project needs or stakeholder requirements.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/Timesheet365/Reports_EZrX33OX9.gif?updatedAt=1720167132311",
  },
];

export const TS3FAQs = [
  {
    title: `1. Does the Microsoft Time tracking app integrate with other Microsoft 365 tools?`,
    content: `Yes, the Microsoft Time tracking app seamlessly integrates with other Microsoft 365 tools like Teams, Outlook, and SharePoint, enabling efficient collaboration and data sharing across the organization.`,
  },
  {
    title: `2. Can I customize the SharePoint Timesheet app to fit my organization’s needs?`,
    content: `Yes, the SharePoint Timesheet app is highly customizable. You can tailor fields, forms, workflows, and approval processes to match your organization’s specific time-tracking requirements.`,
  },
  {
    title: `3. Can I install multiple instances of Timesheet 365? Can I install multiple instances of Timesheet 365?`,
    content: `Yes, you can install multiple instances of the application as long as it is in one Microsoft 365 tenant and total number of users of all the instances installed remain within the user limit as per your plan or license you purchased.`,
  },
  {
    title: `4. How to add task details in weekly bases?`,
    content: `Go to Home page.

Select Timesheet tab. Under that select Weekly Timesheet.

Select the week for which you want to add your projects & task details and click on Add button.

Select the Project, Task and Activity Type from the dropdown list and fill the time spent on a particular task for a selected week, which will automatically calculate

the Total hours spent.`,
  },
  {
    title: `5. Can we clone a weekly timesheet while adding a new weekly timesheet?`,
    content: `Yes, you can clone previous week’s timesheet to the new timesheet if you have worked on the same project & task.

Go to Home page.

Select Timesheets tab.

Choose Clone Weekly Timesheet tab and then click on Clone button.

Project will be added to your Weekly timesheet.

You can mention the time spent for a particular task on each day of the week and click on Submit button.`,
  },
  {
    title: `6. How to add a task?`,
    content: `Go to Home page.

Select the Task tab.

Once the pop-up opens, choose the Project, and enter the Task Name for the respective project.

Then click on submit button. This task would be added into the task list which will fetch while entering your daily timesheet.`,
  },
  {
    title: `7. How to assign a task to an employee?`,
    content: `Select the Assign Task tab.Once the pop-up opens, select the project name and task name and choose a person to whom you want to assign to and click on Submit.ss`,
  },
  {
    title: `8. How to change the theme color in Timesheet Plus - application?`,
    content: `After logging into application, please click on Settings tab on the side-navigation.

In Settings, choose the Pre-defined Themes or you can define your Custom-Themes.`,
  },
  {
    title: `9. How to add new client?`,
    content: `Go to Administrator tab, select Clients.

Once pop-up opens, click on Add button.

You can fill all the client details, and their contact details. If they have documents, you can also attach it.

Once done, you can click on submit button.`,
  },
  {
    title: `10. What is the role of Project Observer?`,
    content: `A Project Observer can view all aspects of a Project. Observers cannot make any changes to the project. Project Observer is a read-only role.`,
  },
];

// AM Pages /sharepoint-asset-management-1

export const AM1FirstSection = {
  MainHeading: "Simplify Asset Management—Because Every Asset Deserves Care",
  MainDescription:
    "Experience seamless asset tracking and management with HR365. From barcoding to lifecycle insights, gain complete control and maximize the value of your assets effortlessly.",
  MainImageAlt: "Assest Management 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/LP%20page/Untitled%20design%20(57)_Fok-LheC9.webp",
};

export const AM1Overview = {
  MainHeading:
    "Simplified Enterprise Asset Management Software with AI Integration",
  MainDescription:
    "Track and manage your assets effortlessly with our AI-powered SharePoint Asset Management system. With automated workflows and intelligent solutions, asset management is streamlined, letting you focus on growing your business.",
  MainImageAlt: "Assest Management 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/Apps365/Teams/image%20(8)_Do7TgjeZV9.png",
};

export const AM1tab1 = [
  {
    id: 1,
    title: "Integrated with Azure",
    Heading: "IT asset management software integrated with Azure",
    content: (
      <ul>
        <li>
          Microsoft Asset Management App integrates seamlessly with Microsoft
          Intune for dynamic asset retrieval and effective management of
          software licenses, service agreements, and Office 365 subscriptions in
          SharePoint.
        </li>
        <li>
          It supports flexible asset allocation across users, groups, and
          locations, optimizing resource use.
        </li>
        <li>
          The robust workflow engine automates renewals, enhancing efficiency,
          while the Azure Asset Management App continuously updates the Azure
          asset inventory for improved management.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/azure_Faooyo8YDz.gif?updatedAt=1720174577090",
  },
  {
    id: 2,
    title: " Featuring Audits",
    Heading: " IT and Physical asset management solutions featuring Audits",
    content: (
      <ul>
        <li>
          Online asset management software simplifies license management and
          reporting, moving away from labor-intensive Excel sheets.
        </li>
        <li>
          It features an audit function to track an asset’s entire lifecycle,
          including assignment dates and usage patterns.
        </li>
        <li>
          You can easily audit contracts, software licenses, and hardware
          configurations, ensuring compliance and identifying underutilized
          equipment.
        </li>
        <li>For detailed insights and a personalized demo, contact us.</li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/featuringAudits_R3se0Mc6pO.gif?updatedAt=1720174577072",
  },
  {
    id: 3,
    title: "Barcode Scanning",
    Heading:
      "Barcode Scanning, Image Capture, and Document Management with SharePoint IT Asset Management solutions",
    content: (
      <ul>
        <li>
          ITAM software generates barcodes and QR codes for easy tracking
          through the asset monitoring app.
        </li>
        <li>
          Asset details can be verified with mobile devices or barcode scanners,
          improving efficiency.
        </li>
        <li>
          The tool also links comprehensive documentation to each asset,
          including manuals, support contacts, and guidelines, ensuring easy
          access to relevant information.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/barcode_RPpEWhHap1.gif?updatedAt=1720174576528",
  },
  {
    id: 4,
    title: "Reports",
    Heading: "Asset Management Application: In-Depth Reports",
    content: (
      <ul>
        <li>Seamless data export to Excel for your convenience.</li>
        <li>
          Effortless customization of column order to match your preferences.
        </li>
        <li>
          Simplified data presentation by eliminating unnecessary columns.
        </li>
        <li>
          Addition of custom columns to incorporate personalized insights.
        </li>
        <li>
          Enhanced data exploration with advanced search capabilities and
          filters.
        </li>
        <li>Automated report generation schedules for regular updates.</li>
        <li>
          Integration with other software tools for comprehensive data analysis
        </li>
        <li>Real-time data synchronization for up-to-date information.</li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/barcode_RPpEWhHap1.gif?updatedAt=1720174576528",
  },
];

export const AM1FAQs = [
  {
    title: "Does SharePoint have asset management?",
    content: `Asset Management System (AMS) is your trusted companion for effortlessly tracking and managing all your assets. Built on Microsoft 365 and SharePoint, it combines simplicity with innovation, making asset tracking a breeze. Asset 365, a Microsoft-certified, cloud-powered solution infused with AI, ensures you stay in control of your valuable assets with ease and confidence.`,
  },
  {
    title: "How to create an asset library in SharePoint?",
    content: (
      <ul>
        Creating an Asset Library in SharePoint is simple:
        <li>Click + New App.</li>
        <li>
          In the classic experience, go to Lists, Libraries, and Other Apps,
          then select Add an App
        </li>
        Note: You'll need permission to create lists. If you do not have the
        required permissions, the + New menu or Add an App option won’t be
        visible.
      </ul>
    ),
  },
  {
    title: "Where is Site Assets in SharePoint?",
    content: (
      <ul>
        To find Site Assets in SharePoint assets:
        <li>Go to Your Site and click the Settings gear icon.</li>
        <li>Select Site Contents from the menu.</li>
        <li>Locate Site Assets in the list.</li>
        <p>
          Note: If you do not find it, you may need permissions or help from
          your SharePoint admin.
        </p>
      </ul>
    ),
  },
  {
    title:
      "What is the difference between SharePoint Asset Management and DAM?",
    content: (
      <ul>
        SharePoint and Digital Asset Management (DAM) serve different purposes:
        <li>
          <b>SharePoint Asset Management: </b>An easy collaboration tool for
          managing documents, workflows, and team projects. Ideal for general
          file sharing and productivity.
        </li>
        <li>
          <b> DAM:</b> A specialized system for organizing and managing media
          assets like images and videos, with features like tagging and rights
          management. Perfect for marketing and creative teams.
        </li>
        <p>
          In short, SharePoint asset management supports team collaboration,
          while DAM focuses on managing rich media content.
        </p>
      </ul>
    ),
  },
];

//AM /sharepoint-asset-management-2"

export const AM2FirstSection = {
  MainHeading: "Simplify Asset Management—Because Every Asset Deserves Care",
  MainDescription:
    "Experience seamless asset tracking and management with HR365. From barcoding to lifecycle insights, gain complete control and maximize the value of your assets effortlessly.",
  MainImageAlt: "Assest Management 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/LP%20page/Untitled%20design%20(57)_Fok-LheC9.webp",
};

export const AM2FAQs = [
  {
    title: "Does SharePoint have asset management?",
    content: `Asset Management System (AMS) is your trusted companion for effortlessly tracking and managing all your assets. Built on Microsoft 365 and SharePoint, it combines simplicity with innovation, making asset tracking a breeze. Asset 365, a Microsoft-certified, cloud-powered solution infused with AI, ensures you stay in control of your valuable assets with ease and confidence.`,
  },
  {
    title: "How to create an asset library in SharePoint?",
    content: (
      <ul>
        Creating an Asset Library in SharePoint is simple:
        <li>Click + New App.</li>
        <li>
          In the classic experience, go to Lists, Libraries, and Other Apps,
          then select Add an App
        </li>
        Note: You'll need permission to create lists. If you do not have the
        required permissions, the + New menu or Add an App option won’t be
        visible.
      </ul>
    ),
  },
  {
    title: "Where is Site Assets in SharePoint?",
    content: (
      <ul>
        To find Site Assets in SharePoint assets:
        <li>Go to Your Site and click the Settings gear icon.</li>
        <li>Select Site Contents from the menu.</li>
        <li>Locate Site Assets in the list.</li>
        <p>
          Note: If you do not find it, you may need permissions or help from
          your SharePoint admin.
        </p>
      </ul>
    ),
  },
  {
    title:
      "What is the difference between SharePoint Asset Management and DAM?",
    content: (
      <ul>
        SharePoint and Digital Asset Management (DAM) serve different purposes:
        <li>
          <b>SharePoint Asset Management: </b>An easy collaboration tool for
          managing documents, workflows, and team projects. Ideal for general
          file sharing and productivity.
        </li>
        <li>
          <b> DAM:</b> A specialized system for organizing and managing media
          assets like images and videos, with features like tagging and rights
          management. Perfect for marketing and creative teams.
        </li>
        <p>
          In short, SharePoint asset management supports team collaboration,
          while DAM focuses on managing rich media content.
        </p>
      </ul>
    ),
  },
];

export const AM2tab1 = [
  {
    id: 1,
    title: "Integrated with Azure",
    Heading: "IT asset management software integrated with Azure",
    content: (
      <ul>
        <li>
          Microsoft Asset Management App integrates seamlessly with Microsoft
          Intune for dynamic asset retrieval and effective management of
          software licenses, service agreements, and Office 365 subscriptions in
          SharePoint.
        </li>
        <li>
          It supports flexible asset allocation across users, groups, and
          locations, optimizing resource use.
        </li>
        <li>
          The robust workflow engine automates renewals, enhancing efficiency,
          while the Azure Asset Management App continuously updates the Azure
          asset inventory for improved management.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/azure_Faooyo8YDz.gif?updatedAt=1720174577090",
  },
  {
    id: 2,
    title: " Featuring Audits",
    Heading: " IT and Physical asset management solutions featuring Audits",
    content: (
      <ul>
        <li>
          Online asset management software simplifies license management and
          reporting, moving away from labor-intensive Excel sheets.
        </li>
        <li>
          It features an audit function to track an asset’s entire lifecycle,
          including assignment dates and usage patterns.
        </li>
        <li>
          You can easily audit contracts, software licenses, and hardware
          configurations, ensuring compliance and identifying underutilized
          equipment.
        </li>
        <li>For detailed insights and a personalized demo, contact us.</li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/featuringAudits_R3se0Mc6pO.gif?updatedAt=1720174577072",
  },
  {
    id: 3,
    title: "Barcode Scanning",
    Heading:
      "Barcode Scanning, Image Capture, and Document Management with SharePoint IT Asset Management solutions",
    content: (
      <ul>
        <li>
          ITAM software generates barcodes and QR codes for easy tracking
          through the asset monitoring app.
        </li>
        <li>
          Asset details can be verified with mobile devices or barcode scanners,
          improving efficiency.
        </li>
        <li>
          The tool also links comprehensive documentation to each asset,
          including manuals, support contacts, and guidelines, ensuring easy
          access to relevant information.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/barcode_RPpEWhHap1.gif?updatedAt=1720174576528",
  },
  {
    id: 4,
    title: "Reports",
    Heading: "Asset Management Application: In-Depth Reports",
    content: (
      <ul>
        <li>Seamless data export to Excel for your convenience.</li>
        <li>
          Effortless customization of column order to match your preferences.
        </li>
        <li>
          Simplified data presentation by eliminating unnecessary columns.
        </li>
        <li>
          Addition of custom columns to incorporate personalized insights.
        </li>
        <li>
          Enhanced data exploration with advanced search capabilities and
          filters.
        </li>
        <li>Automated report generation schedules for regular updates.</li>
        <li>
          Integration with other software tools for comprehensive data analysis
        </li>
        <li>Real-time data synchronization for up-to-date information.</li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/barcode_RPpEWhHap1.gif?updatedAt=1720174576528",
  },
];

//AM  "/sharepoint-asset-management-3",

export const AM3FirstSection = {
  MainHeading: "Simplify Asset Management—Because Every Asset Deserves Care",
  MainDescription:
    "Experience seamless asset tracking and management with HR365. From barcoding to lifecycle insights, gain complete control and maximize the value of your assets effortlessly.",
  MainImageAlt: "Assest Management 365",
  MainImageSrc:
    "https://ik.imagekit.io/zn4au2jftpm5/LP%20page/Untitled%20design%20(57)_Fok-LheC9.webp",
};

export const AM3FAQs = [
  {
    title: "Does SharePoint have asset management?",
    content: `Asset Management System (AMS) is your trusted companion for effortlessly tracking and managing all your assets. Built on Microsoft 365 and SharePoint, it combines simplicity with innovation, making asset tracking a breeze. Asset 365, a Microsoft-certified, cloud-powered solution infused with AI, ensures you stay in control of your valuable assets with ease and confidence.`,
  },
  {
    title: "How to create an asset library in SharePoint?",
    content: (
      <ul>
        Creating an Asset Library in SharePoint is simple:
        <li>Click + New App.</li>
        <li>
          In the classic experience, go to Lists, Libraries, and Other Apps,
          then select Add an App
        </li>
        Note: You'll need permission to create lists. If you do not have the
        required permissions, the + New menu or Add an App option won’t be
        visible.
      </ul>
    ),
  },
  {
    title: "Where is Site Assets in SharePoint?",
    content: (
      <ul>
        To find Site Assets in SharePoint assets:
        <li>Go to Your Site and click the Settings gear icon.</li>
        <li>Select Site Contents from the menu.</li>
        <li>Locate Site Assets in the list.</li>
        <p>
          Note: If you do not find it, you may need permissions or help from
          your SharePoint admin.
        </p>
      </ul>
    ),
  },
  {
    title:
      "What is the difference between SharePoint Asset Management and DAM?",
    content: (
      <ul>
        SharePoint and Digital Asset Management (DAM) serve different purposes:
        <li>
          <b>SharePoint Asset Management: </b>An easy collaboration tool for
          managing documents, workflows, and team projects. Ideal for general
          file sharing and productivity.
        </li>
        <li>
          <b> DAM:</b> A specialized system for organizing and managing media
          assets like images and videos, with features like tagging and rights
          management. Perfect for marketing and creative teams.
        </li>
        <p>
          In short, SharePoint asset management supports team collaboration,
          while DAM focuses on managing rich media content.
        </p>
      </ul>
    ),
  },
];

export const AM3tab1 = [
  {
    id: 1,
    title: "Integrated with Azure",
    Heading: "IT asset management software integrated with Azure",
    content: (
      <ul>
        <li>
          Microsoft Asset Management App integrates seamlessly with Microsoft
          Intune for dynamic asset retrieval and effective management of
          software licenses, service agreements, and Office 365 subscriptions in
          SharePoint.
        </li>
        <li>
          It supports flexible asset allocation across users, groups, and
          locations, optimizing resource use.
        </li>
        <li>
          The robust workflow engine automates renewals, enhancing efficiency,
          while the Azure Asset Management App continuously updates the Azure
          asset inventory for improved management.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/azure_Faooyo8YDz.gif?updatedAt=1720174577090",
  },
  {
    id: 2,
    title: " Featuring Audits",
    Heading: " IT and Physical asset management solutions featuring Audits",
    content: (
      <ul>
        <li>
          Online asset management software simplifies license management and
          reporting, moving away from labor-intensive Excel sheets.
        </li>
        <li>
          It features an audit function to track an asset’s entire lifecycle,
          including assignment dates and usage patterns.
        </li>
        <li>
          You can easily audit contracts, software licenses, and hardware
          configurations, ensuring compliance and identifying underutilized
          equipment.
        </li>
        <li>For detailed insights and a personalized demo, contact us.</li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/featuringAudits_R3se0Mc6pO.gif?updatedAt=1720174577072",
  },
  {
    id: 3,
    title: "Barcode Scanning",
    Heading:
      "Barcode Scanning, Image Capture, and Document Management with SharePoint IT Asset Management solutions",
    content: (
      <ul>
        <li>
          ITAM software generates barcodes and QR codes for easy tracking
          through the asset monitoring app.
        </li>
        <li>
          Asset details can be verified with mobile devices or barcode scanners,
          improving efficiency.
        </li>
        <li>
          The tool also links comprehensive documentation to each asset,
          including manuals, support contacts, and guidelines, ensuring easy
          access to relevant information.
        </li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/barcode_RPpEWhHap1.gif?updatedAt=1720174576528",
  },
  {
    id: 4,
    title: "Reports",
    Heading: "Asset Management Application: In-Depth Reports",
    content: (
      <ul>
        <li>Seamless data export to Excel for your convenience.</li>
        <li>
          Effortless customization of column order to match your preferences.
        </li>
        <li>
          Simplified data presentation by eliminating unnecessary columns.
        </li>
        <li>
          Addition of custom columns to incorporate personalized insights.
        </li>
        <li>
          Enhanced data exploration with advanced search capabilities and
          filters.
        </li>
        <li>Automated report generation schedules for regular updates.</li>
        <li>
          Integration with other software tools for comprehensive data analysis
        </li>
        <li>Real-time data synchronization for up-to-date information.</li>
      </ul>
    ),
    image:
      "https://ik.imagekit.io/zn4au2jftpm5/Apps365/GIF/AM365/barcode_RPpEWhHap1.gif?updatedAt=1720174576528",
  },
];



export const getAppName = () => {
  const PageURL = window.location.href?.toLowerCase();

  if (PageURL.includes("employee-directory-365")|| PageURL.includes("directory") ) {
    return "Employee Directory 365";
  } else if (PageURL.includes("helpdesk-365") || PageURL.includes("helpdesk") || PageURL.includes("helpdesk-software")) {
    return "Helpdesk 365";
  } else if (PageURL.includes("asset-management-365") ||  PageURL.includes("asset")) {
    return "Asset 365";
  } else if (PageURL.includes("time-off-manager-365") || PageURL.includes("leave") || PageURL.includes("leave-management")) {
    return "Time Off Manager 365";
  } else if (PageURL.includes("employee-onboarding-365") || PageURL.includes("onboarding")) {
    return "Employee Onboarding 365";
  } else if (PageURL.includes("performance-management-365") || PageURL.includes("performance")) {
    return "Performance Management 365";
  } else if (PageURL.includes("sharepoint-contract-management-software") || PageURL.includes("contract-management-365") || PageURL.includes("contract")) {
    return "CLM 365 - Contract Management";
  } else if (PageURL.includes("task-management-365") || PageURL.includes("task")) {
    return "Task 365";
  } else if (PageURL.includes("revenue-365")) {
    return "Revenue 365";
  } else if (PageURL.includes("civic-365")) {
    return "Civic 365";
  } else if (PageURL.includes("hr365-best-hr-management-software-hr") || PageURL.includes("human")) {
    return "HRMS";
  } else if (PageURL.includes("microsoft-recruitment-software") || PageURL.includes("recruitment-365")) {
    return "Recruitment Software 365";
  } else if (PageURL.includes("lms-365") || PageURL.includes("learning-management-365")) {
    return "LMS 365";
  } else if (PageURL.includes("expense-tracker-365") || PageURL.includes("expense-365") || PageURL.includes("expense") || PageURL.includes("expense-tracker")) {
    return "Expense 365";
  } else if (PageURL.includes("sharepoint-timesheet") || PageURL.includes("timesheet-365")) {
    return "Timesheet 365";
  } else {
    return SiteName === "HR365" ? "lp.hr365.us" : "lp.apps365.com";
  }
};